import Vue from 'vue'
import Vuex from 'vuex'
import './unit'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        debuMode: false,
        isLoged: false,
        calculatingPercentage: 0,
        activeConfigurationStep: 1,
        isAdjustResultDisabled: false,
        lastPathParameters: null,
        activeLang: {
            name: 'Polski',
            imgName: 'poland'
        },

        events: {
            needReload: false,
            stamp: '',
            description: '',
            userId: 0
        },

        languages: [
            {
                name: 'English',
                imgName: 'england',
                active: false
            },
            {
                name: 'Deutsch',
                imgName: 'germany',
                active: false
            },
            {
                name: 'Русский',
                imgName: 'russia',
                active: false
            },
        ],

        isUserLogged: false,

        offerSearchResults: [],

        offerSearchQuery: '',

        globalInputLock: false,

        userId: '',

        userRole: '',

        userEmail: 'Guest',

        discount: {
            userDiscountValue: 0,
            offerDiscountGivenByTheAdministrator: 0,
            additionalDiscount: 0
        },

        notifications: [],

        translations: [],

        fansInAtexTypes: [],

        offerSurcharges: [],

        // NVS-95
        offerDiscounts: [],

        appVariables: [],

        appSettings: [],

        engineTemperatureRanges: [],

        engineEfficiencyRanges: [],

        numberOfChoices: 0,

        selectedFirstStepElement: {
            id: -1,
            name: '',
            imgName: '',
            description: '',
            default_minimum_material_density: 0,
            default_minimum_material_density_value: 0,
            delta_t_condition_check: 0,
        },

        selectedSecondStepElement: {
            id: -1,
            name: '',
            imgName: ''
        },

        selectedThirdStepElement: {
            id: -1,
            name: '',
            imgName: '',
            description: ''
        },

        selectedFourthStepElement: {
            id: -1,
            name: '',
            imgName: '',
            description: ''
        },

        lastCalculationSelectedPressureType: null,

        firstStepElements: [
            // {
            //     name: 'Do czystego powietrza',
            //     imgName: 'do_czystego_powietrza.png',
            //     description: 'Wentylatory na czyste powietrze, są przeznaczone do przetłaczania czystego bądź poddanego ' +
            //         'wcześniejszej filtracji powietrza. Najczęściej znajdują zastosowanie w filtrach pracujących na podciśnieniu.'
            // },
            // {
            //     name: 'Do pyłów',
            //     imgName: 'do_pyłów.png',
            //     description: 'Wentylatory na czyste powietrze, są przeznaczone do przetłaczania czystego bądź poddanego ' +
            //         'wcześniejszej filtracji powietrza. Najczęściej znajdują zastosowanie w filtrach pracujących na podciśnieniu.'
            // },
            // {
            //     name: 'Transportowe',
            //     imgName: 'transportowe.png',
            //     description: 'Wentylatory na czyste powietrze, są przeznaczone do przetłaczania czystego bądź poddanego ' +
            //         'wcześniejszej filtracji powietrza. Najczęściej znajdują zastosowanie w filtrach pracujących na podciśnieniu.'
            // },
            // {
            //     name: 'Tnące',
            //     imgName: 'tnące.png',
            //     description: 'Wentylatory na czyste powietrze, są przeznaczone do przetłaczania czystego bądź poddanego ' +
            //         'wcześniejszej filtracji powietrza. Najczęściej znajdują zastosowanie w filtrach pracujących na podciśnieniu.'
            // },
        ],

        secondStepElements: [
            {
                name: 'Jeden wentylator',
                imgName: 'single_circulation.svg',
            },
            {
                name: 'Połączenie równoległe',
                imgName: 'double_circulation.svg'
            }
        ],

        thirdStepElements: [
            {
                name: 'Pył',
                imgName: 'pyl.png',
            },
            {
                name: 'Wióry i trociny',
                imgName: 'wiory_i_trociny.png'
            },
            {
                name: 'Zrębki',
                imgName: 'zrebki.png'
            },
            {
                name: 'Stróżyny krótkie',
                imgName: 'strozyny_krotkie.png'
            },
            {
                name: 'Heblowiny\n' +
                    'i stróżyny',
                imgName: 'heblowiny_i_strozyny.png'
            },
            {
                name: 'Ścinki papiery',
                imgName: 'scinki_papiery.png'
            },
            {
                name: 'Granulat',
                imgName: 'granulat.png'
            },
            {
                name: 'Ziarna',
                imgName: 'ziarna.png'
            }
        ],
        showPowerLine: false,
        selectedWorkPoint: null,
        fourthStepParametersSelected: {},

        bafaSearchQuery: '',
        bafaSearchActive: false,

        bafaParameters: {
            network_frequency: {
                active: true,
                title: 'Częstotliwość sieci',
                options: {

                    0: {
                        name: "workPointBaseFrequency",
                        type: 'radio',
                        elements: {

                            0: {
                                value: '50',
                                displayValue: '50 Hz',
                                active: true,
                                locked: false,
                                default: true,
                            },

                            1: {
                                value: '60',
                                displayValue: '60 Hz',
                                active: false,
                                locked: false
                            }
                        }
                    }
                }
            },

            work_on_the_inverter: {
                active: true,
                title: 'Praca na falowniku',
                options: {
                    0: {
                        type: 'radio',
                        elements: {
                            0: {
                                value: 'no',
                                active: true,
                                default: true,
                            },
                            1: {
                                value: 'yes',
                                active: false
                            }
                        }
                    },
                }
            },

            work_frequency: {
                active: true,
                type: 'row',
                title: "Częstotliwośc pracy",
                options: [
                    {
                        title_translation_code: "work_frequency",
                        active: true,
                        type: 'value',
                        value: 50,
                        min_value: 0,
                        max_value: 50,
                        step: 0.1,
                        unit: {
                            name: "Hz",
                            decimal_places: 1
                        }
                    },
                    {
                        title_translation_code: "work_frequency_range",
                        locked: true,
                        type: 'value_min_max',
                        value_min: 0,
                        value_max: 0,
                        unit: {
                            name: "Hz",
                            decimal_places: 1
                        }
                    },
                ]
            },
        },
        // NVS-78 Opcje dla kalkulatora wydajności normalnej
        calculatorParameters: {
            'pressure': {
                active: true,
                title: 'Ciśnienie żądane',
                name: "workPointPressure",
                value: 0,
                options: {
                    // 0: {
                    //     name: "workPointPressureType",
                    //     type: 'radio',
                    //     elements: {
                    //         0: {
                    //             value: 'total',
                    //             active: true,
                    //             default: true,
                    //         },
                    //         1: {
                    //             value: 'static',
                    //             active: false
                    //         }
                    //     }
                    // },

                    1: {
                        type: 'select',
                        disabled: false,
                        defaultDisabled: false,
                        unitType: "pressure",
                        elements: {

                            0: {
                                value: 'Pa',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'HPa',
                                active: false
                            },

                            2: {
                                value: 'atm',
                                active: false
                            }
                        }
                    }
                }
            },
            'above_sea': {
                active: true,
                title: 'Wysokość n.p.m.',
                name: "workPointAboveSea",
                value: 0,
                options: {

                    0: {
                        type: 'select',
                        disabled: false,
                        defaultDisabled: false,
                        unitType: "length",
                        elements: {
                        }
                    }
                }
            },
            'temperature': {
                active: true,
                title: 'Temperatura',
                name: 'workPointTemperature',
                defaultValue: 293.15,
                value: 293.15,//temperatura zapisana w jednostce kelwin
                options: {

                    0: {
                        type: 'select',
                        disabled: false,
                        defaultDisabled: false,
                        unitType: "temperature",
                        elements: {
                        }
                    }
                }
            },
            'atmospheric_pressure': {
                active: true,
                title: 'Ciśnienie atmosferyczne',
                name: "atmospheric_pressure",
                value: 0,
                options: {
                    0: {
                        name: "atmosphericPressureType",
                        type: 'radio',
                        disabled: false,
                        defaultDisabled: false,
                        elements: {
                            0: {
                                value: 'calculate',
                                active: true,
                                default: true,
                            },
                            1: {
                                value: 'enter',
                                active: false
                            }
                        }
                    },

                    1: {
                        type: 'select',
                        disabled: true,
                        defaultDisabled: true,
                        unitType: "pressure",
                        elements: {

                            0: {
                                value: 'Pa',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'HPa',
                                active: false
                            },

                            2: {
                                value: 'atm',
                                active: false
                            }
                        }
                    }
                }
            },
            // NVS-107
            'calculated_pressure': {
                active: true,
                title: 'Obliczone ciśnienie',
                name: "calculated_pressure",
                value: 0,
                options: {
                    0: {
                        type: 'select',
                        disabled: true,
                        defaultDisabled: true,
                        unitType: "pressure",
                        elements: {

                            0: {
                                value: 'Pa',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'HPa',
                                active: false
                            },

                            2: {
                                value: 'atm',
                                active: false
                            }

                        }
                    }
                }
            },
            'normal_performance': {
                active: true,
                title: 'Wydajność normalna',
                name: "normal_performance",
                value: 0,
                options: {
                    0: {
                        type: 'select',
                        disabled: false,
                        defaultDisabled: false,
                        unitType: "performance",
                        elements: {

                            0: {
                                value: 'm3/h',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'm3/s',
                                active: false
                            },

                        }
                    }
                }
            },
            'calculated_performance': {
                active: true,
                title: 'Obliczona wydajność',
                name: "calculated_performance",
                value: 0,
                options: {
                    0: {
                        type: 'select',
                        disabled: true,
                        defaultDisabled: true,
                        unitType: "performance",
                        elements: {

                            0: {
                                value: 'm3/h',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'm3/s',
                                active: false
                            },

                        }
                    }
                }
            }
        },

        fourthStepParameters: {

            'fan_position': {
                active: true,
                title: 'Typ wentylatora',
                options: {

                    0: {
                        type: 'radio',
                        elements: {

                            0: {
                                value: 'lying',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'standing',
                                active: false
                            }
                        }
                    }
                }
            },

            'network_frequency': {
                active: true,
                title: 'Częstotliwość sieci',
                options: {

                    0: {
                        name: "workPointBaseFrequency",
                        type: 'radio',
                        elements: {

                            0: {
                                value: '50',
                                displayValue: '50 Hz',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: '60',
                                displayValue: '60 Hz',
                                active: false
                            }
                        }
                    }
                }
            },

            'electricity': {
                active: true,
                title: 'Prąd',
                removable: true,
                options: {

                    current_phase: {
                        type: 'radio',
                        elements: {

                            Phase3: {
                                value: "3",
                                displayValue: '3_phases',
                                active: true,
                                default: true,
                            },

                            Phase1: {
                                value: "1",
                                displayValue: '1_phase',
                                active: false
                            }
                        }
                    },

                    current_type: {
                        type: 'radio',
                        elements: {

                            AC: {
                                value: 'AC',
                                displayValue: "AC~",
                                active: true,
                                default: true,
                            },

                            DC: {
                                value: 'DC',
                                displayValue: "DC~",
                                active: false
                            }
                        }
                    }
                }
            },

            'pressure': {
                active: true,
                title: 'Ciśnienie żądane',
                name: "workPointPressure",
                value: 0,
                options: {
                    0: {
                        name: "workPointPressureType",
                        type: 'radio',
                        elements: {
                            0: {
                                value: 'total',
                                active: true,
                                default: true,
                            },
                            1: {
                                value: 'static',
                                active: false
                            }
                        }
                    },

                    1: {
                        type: 'select',
                        unitType: "pressure",
                        elements: {

                            0: {
                                value: 'Pa',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'HPa',
                                active: false
                            },

                            2: {
                                value: 'atm',
                                active: false
                            }
                        }
                    }
                }
            },

            'performance': {
                active: true,
                title: 'Wydajność',
                name: "workPointPerformance",
                value: 0,
                options: {
                    0: {
                        type: 'select',
                        unitType: "performance",
                        elements: {

                            0: {
                                value: 'm3/h',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'cm3/h',
                                active: false
                            },

                        }
                    }
                }
            },

            // ///////////////////testowo///
            // 'performenceHour': {
            //     active: true,
            //     title: 'Wydajność',
            //     name: "workPointPerformanceHour",
            //     value: 0,
            //     unitType: "performence",
            //     options: {
            //
            //         0: {
            //             type: 'select',
            //             elements: {
            //
            //                 0: {
            //                     value: 'm3/h',
            //                     active: true
            //                 },
            //
            //                 1: {
            //                     value: 'cm3/h',
            //                     active: false
            //                 },
            //
            //                 2: {
            //                     value: 'mm3/h',
            //                     active: false
            //                 }
            //             }
            //         }
            //     }
            // },
            // ///////////////koniec testowo///////

            'above_sea': {
                active: true,
                title: 'Wysokość n.p.m.',
                name: "workPointAboveSea",
                value: 0,
                options: {

                    0: {
                        type: 'select',
                        unitType: "length",
                        elements: {

                            // 0: {
                            //     value: 'm',
                            //     active: true
                            // },
                            //
                            // 1: {
                            //     value: 'cm',
                            //     active: false
                            // },
                            //
                            // 2: {
                            //     value: 'mm',
                            //     active: false
                            // }
                        }
                    }
                }
            },

            'temperature': {
                active: true,
                title: 'Temperatura',
                name: 'workPointTemperature',
                defaultValue: 293.15,
                value: 293.15,//temperatura zapisana w jednostce kelwin
                options: {

                    0: {
                        type: 'select',
                        unitType: "temperature",
                        elements: {
                            // 0: {
                            //     value: '&#8451;',
                            //     active: true
                            // },
                            //
                            // 1: {
                            //     value: '&#8457;',
                            //     active: false
                            // }
                        }
                    }
                }
            },

            //////////////////testowo 2//////////
            // 'temperatureKelwin': {
            //     active: true,
            //     title: 'Temperatura',
            //     name: 'workPointTemperature',
            //     value: 293,
            //     options: {
            //
            //         0: {
            //             type: 'select',
            //             elements: {
            //
            //                 0: {
            //                     value: '&#8451;',
            //                     active: true
            //                 },
            //
            //                 1: {
            //                     value: '&#8457;',
            //                     active: false
            //                 }
            //             }
            //         }
            //     }
            // },
            'workPointAirDensityCalced': {
                active: true,
                title: 'Temperatura',
                name: 'workPointAirDensityCalced',
                value: 0,
                options: {

                    0: {
                        type: 'select',
                        elements: {

                            0: {
                                value: '&#8451;',
                                active: true
                            },

                            1: {
                                value: '&#8457;',
                                active: false
                            }
                        }
                    }
                }
            },
            'workPointAirDensity': {
                active: true,
                title: 'Temperatura',
                name: 'workPointAirDensity',
                value: 0,
                options: {

                    0: {
                        type: 'select',
                        elements: {

                            0: {
                                value: '&#8451;',
                                active: true
                            },

                            1: {
                                value: '&#8457;',
                                active: false
                            }
                        }
                    }
                }
            },

            'workPointAirDensityTotal': {
                active: true,
                title: 'Ilość i zagęszczenie materiału',
                value: 0,
                name: "workPointAirDensityTotal",
                options: {

                    0: {
                        type: 'select',
                        elements: {

                            0: {
                                value: 'kg/h',
                                active: true
                            },
                        }
                    },

                    1: {
                        type: 'select',
                        elements: {
                            0: {
                                value: 'g/m^3',
                                active: true
                            },

                        }
                    }
                }
            },
            'workPointFrequency': {
                active: true,
                title: 'Ilość i zagęszczenie materiału',
                value: 50,
                name: "workPointFrequency",
                options: {

                    0: {
                        type: 'select',
                        elements: {

                            0: {
                                value: 'kg/h',
                                active: true
                            },
                        }
                    },

                    1: {
                        type: 'select',
                        elements: {
                            0: {
                                value: 'g/m^3',
                                active: true
                            },

                        }
                    }
                }
            },
            'workPointRotationSpeed': {
                active: true,
                title: 'Ilość i zagęszczenie materiału',
                value: 0,
                name: "workPointRotationSpeed",
                options: {

                    0: {
                        type: 'select',
                        elements: {

                            0: {
                                value: 'kg/h',
                                active: true
                            },
                        }
                    },

                    1: {
                        type: 'select',
                        elements: {
                            0: {
                                value: 'g/m^3',
                                active: true
                            },

                        }
                    }
                }
            },
            'summaryTotalPressure': {//TODO: Ta wartość powinna być checkboxem
                active: false,
                title: 'Ilość i zagęszczenie materiału',
                options: {

                    0: {
                        name: "summaryTotalPressure",
                        type: 'radio',
                        elements: {

                            0: {
                                value: true,
                                active: true
                            },
                        }
                    },

                }
            },
            'summaryStaticPressure': {//TODO: Ta wartość powinna być checkboxem
                active: false,
                title: 'Ilość i zagęszczenie materiału',
                options: {

                    0: {
                        name: "summaryStaticPressure",
                        type: 'radio',
                        elements: {

                            0: {
                                value: true,
                                active: true
                            },
                        }
                    },

                }
            },
            'summaryDynamicPressure': {//TODO: Ta wartość powinna być checkboxem
                active: false,
                title: 'Ilość i zagęszczenie materiału',

                options: {

                    0: {
                        name: "summaryDynamicPressure",
                        type: 'radio',
                        elements: {

                            0: {
                                value: true,
                                active: true
                            },
                        }
                    },
                }
            },
            //////////////////koniec testowo 2//////////

            'material_amount': {
                active: true,
                title: 'Ilość materiału',
                value: 0,
                name: "workPointAmount",//TODO: tutaj jest także zagęszczenie materiału
                options: {

                    0: {
                        type: 'select',
                        unitType: "materialAmount",
                        elements: {}
                    },

                }
            },
            'material_density': {
                active: true,
                title: 'Zagęszczenie materiału',
                value: 0,
                name: "workPointAmountUnit",
                options: {

                    0: {
                        type: 'select',
                        unitType: "density",
                        elements: {

                            0: {
                                value: 'kg/h',
                                active: true
                            },
                        }
                    },
                }
            },

            'pipeline_diameter': {
                active: true,
                title: 'Średnica rurociągu',
                value: 0,
                options: {

                    0: {
                        type: 'select',
                        unitType: "length",
                        elements: {

                            0: {
                                value: 'cm',
                                active: true
                            },

                            1: {
                                value: 'm',
                                active: false
                            }
                        }
                    }
                }
            },

            'number_of_fans_on_the_inverter': {
                // active: true,
                // title: 'Ilość wentylatorów na falowniku',
                // value: 1,
                // options: {
                //
                //     0: {
                //         type: 'select',
                //         elements: {
                //
                //             0: {
                //                 value: 'szt',
                //                 active: true
                //             },
                //         }
                //     }
                // }

                active: true,
                title: 'Ilość wentylatorów na falowniku',
                options: {

                    0: {
                        type: 'radio',
                        elements: {

                            0: {
                                value: '1',
                                displayValue: 'amount_szt_1',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: '0',
                                displayValue: 'amount_szt_0',
                                active: false,
                                default: false,
                            }
                        }
                    }
                }
            },

            'work_on_the_inverter': {
                active: true,
                title: 'Praca na falowniku',
                options: {

                    0: {
                        type: 'radio',
                        elements: {
                            0: {
                                value: 'no',
                                active: true,
                                default: true,
                            },
                            1: {
                                value: 'yes',
                                active: false
                            }
                        }
                    }
                }
            },

            'ex': {
                active: true,
                title: 'Ex',
                options: {

                    0: {
                        type: 'radio',
                        elements: {
                            0: {
                                value: 'no',
                                active: true,
                                default: true,
                            },
                            1: {
                                value: 'yes',
                                active: false
                            }
                        }
                    },

                    1: {
                        type: 'select',
                        value: 'where',
                        name: 'where',
                        elements: {

                            0: {
                                value: 'inside',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'outside',
                                active: false
                            },

                            2: {
                                value: 'inside_and_outside',
                                active: false
                            }
                        }
                    },

                    2: {
                        type: 'select',
                        value: 'ex_number',
                        name: 'ex_number',
                        elements: {
                            0: {
                                value: '1',
                                hidden: false,
                                active: false
                            },

                            1: {
                                value: '2',
                                hidden: false,
                                active: false
                            },

                            2: {
                                value: '1 + 2',
                                hidden: true,
                                active: false
                            },

                            3: {
                                value: '21',
                                hidden: false,
                                active: false
                            },

                            4: {
                                value: '22',
                                hidden: false,
                                active: true,
                                default: true,
                            },

                            5: {
                                value: '21 + 22',
                                hidden: true,
                                active: false
                            }
                        }
                    }
                }
            },
            // NVS-78 Dorzucam tutaj bo może się przydać w przyszłości
            'atmospheric_pressure': {
                active: false,
                title: 'Ciśnienie atmosferyczne',
                name: "atmospheric_pressure",
                value: 0,
                options: {
                    0: {
                        name: "atmosphericPressureType",
                        type: 'radio',
                        elements: {
                            0: {
                                value: 'calculate',
                                active: true,
                                default: true,
                            },
                            1: {
                                value: 'enter',
                                active: false
                            }
                        }
                    },

                    1: {
                        type: 'select',
                        unitType: "pressure",
                        elements: {

                            0: {
                                value: 'Pa',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'HPa',
                                active: false
                            },

                            2: {
                                value: 'atm',
                                active: false
                            }
                        }
                    }
                }
            },
            'normal_performance': {
                active: false,
                title: 'Wydajność normalna',
                name: "normal_performance",
                value: 0,
                options: {
                    0: {
                        type: 'select',
                        unitType: "performance",
                        elements: {

                            0: {
                                value: 'm3/h',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'm3/s',
                                active: false
                            },

                        }
                    }
                }
            },
            'calculated_performance': {
                active: false,
                title: 'Obliczona wydajność',
                name: "calculated_performance",
                value: 0,
                options: {
                    0: {
                        type: 'select',
                        unitType: "performance",
                        elements: {

                            0: {
                                value: 'm3/h',
                                active: true,
                                default: true,
                            },

                            1: {
                                value: 'm3/s',
                                active: false
                            },

                        }
                    }
                }
            }
        },

        detailsParamsUpdateTime: 0,
        detailsParams: {},
        detailsShowOryginalFrequency: true,
        detailedGraphs: {

            title: 'Wykresy szczegółowe',
            elements: {

                'total_pressure': {
                    title: 'Ciśnienie całkowite',
                    graph: {
                        url: '/gfx/imgs/sample_graph.png'
                    }
                },

                'total_efficiency': {
                    title: 'Sprawność całkowita',
                    graph: {
                        url: '/gfx/imgs/sample_graph.png'
                    }
                },

                'power_on_the_shaft': {
                    title: 'Moc na wale',
                    graph: {
                        url: '/gfx/imgs/sample_graph.png'
                    }
                },

                'static_efficiency': {
                    title: 'Sprawność statyczna',
                    graph: {
                        url: '/gfx/imgs/sample_graph.png'
                    }
                }
            }
        },

        similarFuns: {

            title: 'Podobne wentylatory',
            elements: {

                0: {
                    title: 'TS-EN',
                    param: '09/100/56/01',
                    amount: 1
                },

                1: {
                    title: 'TS-EN',
                    param: '09/100/56/02',
                },

                2: {
                    title: 'TS-EN',
                    param: '09/100/56/04',
                },

                3: {
                    title: 'TS-EN',
                    param: '09/100/56/05',
                    amount: 2
                },

                4: {
                    title: 'TS-EN',
                    param: '09/100/56/06',
                    amount: 8
                },

                5: {
                    title: 'TS-EN',
                    param: '09/100/56/07',
                },

                6: {
                    title: 'TS-EN',
                    param: '09/100/56/08',
                    amount: 5
                },

                7: {
                    title: 'TS-EN',
                    param: '09/100/56/09',
                },

                8: {
                    title: 'TS-EN',
                    param: '09/100/56/10',
                },
            }
        },

        activeFun: {
            id: 0,
            name: '-',
            type: '-',
            model: '-',
            price: 0,
            src: '-',
            suctionConnection: {}, //conn
            pressingConnection: {}, //conn
            engine: null,
            selectedFanData: null,
            data: null,
            count: 1,
        },

        fanToCompare: {
            id: 0,
            name: '-',
            type: '-',
            model: '-',
            price: 0,
            src: '-',
            data: null,
            params: [],
            engine: null,
            selectedFanData: null,
        },

        workPointParameters: {

            title: 'work_point',
            elements: {

                /////////////////////Tylko do wyliczeń ///////////////////////////
                'maximum_total_pressure': {
                    workPointId: "maximum_total_pressure",
                    requestedValue: "",
                    //title: 'Ciśnienie całkowite [Pa]:',
                    active: false,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0',
                    unit: '-'
                },
                'maximum_static_pressure': {
                    workPointId: "maximum_static_pressure",
                    requestedValue: "",
                    //title: 'Ciśnienie całkowite [Pa]:',
                    active: false,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0',
                    unit: '-'
                },
                //////////////////////////////////////////////////////////////////

                'air_density': {
                    workPointId: "AirDensity",
                    requestedValue: "",
                    //title: 'Ciśnienie całkowite [Pa]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '8',
                    unit: 'Pa'
                },

                'performance': {
                    workPointId: "Performance",//TODO: sprawdzić!!!
                    requestedValue: "",
                    //title: 'Sprawność calkowita [-]:',
                    active: true,
                    multippleByNumberOfFans: true,
                    displayCountOfFans: false,
                    value: '9,15',
                    unit: 'Pa'
                },

                'total_pressure': {
                    workPointId: "TotalPressure",
                    requestedValue: "",
                    //title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pa'
                },

                'static_pressure': {
                    workPointId: "StaticPressure",
                    requestedValue: "",
                    //title: 'Sprawność statyczna [-]: ',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '-54926',
                    unit: 'Pa'
                },

                'static_efficiency': {
                    workPointId: "StaticEfficiency",
                    requestedValue: "",
                    // title: 'Sprawność statyczna [-]: ',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '-54926',
                    unit: 'Pa'
                },

                'total_efficiency': {
                    workPointId: "TotalEfficiency",
                    requestedValue: "",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pa'
                },

                'static_pressure_increase': {
                    workPointId: "StaticPressureIncrease",
                    requestedValue: "",
                    //title: 'Przyrost ciśnienia statycznego [-]: ',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pa'
                },

                'dynamic_pressure': {
                    workPointId: "DynamicPressure",
                    requestedValue: "",
                    //title: 'Sprawność calkowita [-]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '9,15',
                    unit: 'Pa'
                },

                'noise': {
                    workPointId: "Noise",
                    requestedValue: "",
                    // title: 'Sprawność calkowita [-]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: true,
                    value: '9,15',
                    unit: 'Pa'
                },

                'noise_lpa': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'noise_lwa': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'power_on_shaft': {
                    workPointId: "PowerOnShaft",
                    requestedValue: "",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: true,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pa'
                },

                'power_on_shaft_with_material': {
                    workPointId: "PowerOnShaftWithMaterial",
                    requestedValue: "",
                    // title: 'Sprawność statyczna [-]: ',
                    active: true,
                    multippleByNumberOfFans: true,
                    displayCountOfFans: false,
                    value: '0',
                    unit: 'Pabaga'
                },

                'installed_power': {
                    workPointId: "",
                    paramsTableId: "installed_power",
                    requestedValue: "",
                    // title: 'Sprawność calkowita [-]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: true,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'electrical_power': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },


                // 'electrical_power_with_material': {
                //     connected:"electrical_power",
                //     workPointId: "",
                //     requestedValue: "",
                //     calculated: true,
                //     // title: 'Moc na wale [kW]:',
                //     active: true,
                //     value: '0,0',
                //     unit: 'Pabaga'
                // },

                'amperage_v1': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'amperage_v2': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'material_amount': {
                    workPointId: "?data?_workPointAmount",
                    requestedValue: "",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: 0,
                    unit: 'Pabaga'
                },

                'material_density': {
                    workPointId: "?data?_workPointAmountUnit",
                    requestedValue: "",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'pipeline_diameter': {
                    workPointId: "",
                    requestedValue: "pipeline_diameter",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'pipeline_average_speed': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '100000',
                    unit: 'Pabaga'
                },

                'characteristic_coefficient': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'work_frequency': {
                    workPointId: "Frequency",
                    requestedValue: "",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'casing_dimensions': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: true,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'weight': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: true,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'number_of_fans': {
                    workPointId: "",
                    requestedValue: "",
                    paramsTableId: "number_of_fans",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '1',
                    unit: 'Pabaga'
                },

                // 'minimum_work_pressure': {
                //     workPointId: "",
                //     requestedValue: "",
                //     calculated: true,
                //     // title: 'Moc na wale [kW]:',
                //     active: true,
                //     value: '0,0',
                //     unit: 'Pabaga'
                // },

                'minimum_air_amount': {
                    workPointId: "?data?_range_min",
                    requestedValue: "",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: true,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'minimum_frequency_on_the_inverter': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'minimum_amount_of_air_at_the_minimum_frequency': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: '-'
                },

                'average_length_of_the_shredded_material': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'average_rated_speed_of_the_fan': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'maximum_rotor_speed': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'number_of_poles': {
                    workPointId: "",
                    requestedValue: "",
                    paramsTableId: "number_of_poles",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'price': {
                    workPointId: "",
                    requestedValue: "",
                    paramsTableId: "price",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'rotor_type': {
                    workPointId: "",
                    requestedValue: "",
                    paramsTableId: "rotor_type",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'fan_type': {
                    workPointId: "",
                    requestedValue: "",
                    paramsTableId: "fan_type",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '-',
                    unit: "-"
                },

                'fan_type_number': {
                    workPointId: "",
                    requestedValue: "",
                    paramsTableId: "fan_type_number",
                    // title: 'Moc na wale [kW]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '-',
                    unit: "-"
                },

                'drive': {
                    workPointId: "",
                    requestedValue: "",
                    paramsTableId: "drive",
                    active: true,
                    calculated: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '-',
                    unit: "-"
                },

                'fan_temperature_increase': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Wzrost temperatury w wentylatorze Δt [°C]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                },

                'max_medium_temperature': {
                    workPointId: "",
                    requestedValue: "",
                    calculated: true,
                    // title: 'Wzrost temperatury w wentylatorze Δt [°C]:',
                    active: true,
                    multippleByNumberOfFans: false,
                    displayCountOfFans: false,
                    value: '0,0',
                    unit: 'Pabaga'
                }


                // 'fan_graphics': {
                //     // title: 'Moc na wale [kW]:',
                //     active: true,
                //     value: '0,0'
                // },
            }
        },

        partsOfTheGraphChanged: 0,
        partsOfTheGraph: {
            title: 'components_of_the_chart',
            mainAxisParams: {

                pressure: {

                    title: 'gp_pressure',
                    active: true,
                    color: '#000000',
                    specificParts: {

                        TotalPressure: {
                            title: 'gp_total_pressure',
                            active: true,
                            color: '#090DDA'
                        },

                        StaticPressure: {
                            title: 'gp_static_pressure',
                            active: false,
                            color: '#12B1F3'
                        },

                        DynamicPressure: {
                            title: 'gp_dynamic_pressure',
                            active: true,
                            color: '#9866D0'
                        },

                        StaticPressureIncrease: {
                            title: 'gp_static_pressure_increase',
                            active: false,
                            color: '#E212C6'
                        },
                    }
                },

                efficiency: {

                    title: 'gp_efficiency',
                    active: false,
                    color: '#DCAD15',
                    specificParts: {

                        TotalEfficiency: {
                            title: 'gp_total_efficiency',
                            active: false,
                            color: '#DCAD15'
                        },

                        StaticEfficiency: {
                            title: 'gp_static_efficiency',
                            active: false,
                            color: '#EF5C19'
                        }
                    }
                },

                power: {

                    title: 'gp_power',
                    active: false,
                    color: '#F30C0C',
                    specificParts: {

                        PowerOnShaft: {
                            title: 'gp_power_on_shaft',
                            active: true,
                            color: '#F30C0C'
                        },

                        PowerOnShaftWithMaterial: {
                            title: 'gp_power_on_shaft_with_material',
                            active: false,
                            color: '#FB8585'
                        },

                        ElectricalPower: {
                            title: 'gp_electrical_power',
                            active: false,
                            color: '#880101'
                        }
                    }
                },

                noise: {

                    title: 'gp_noise_title',
                    active: false,
                    color: '#38B53F',
                    specificParts: {

                        Noise: {
                            title: 'gp_noise',
                            active: false,
                            color: '#38B53F'
                        }
                    }
                },


                current: {
                    title: 'gp_current',
                    active: false,
                    color: '#26BBBB',
                    specificParts: {

                        Amperage: {
                            title: 'gp_amperage_v1',
                            active: false,
                            color: '#26BBBB'
                        },

                        AmperageV2: {
                            title: 'gp_amperage_v2',
                            active: false,
                            color: '#208C8A'
                        }
                    }
                },


                // noiseR: {
                //
                //     title: 'Hałas (L)',
                //     active: false,
                //     color: '#2a435e',
                //     specificParts: {
                //
                //         noise_wa: {
                //             title: 'Hałas (Lwa)',
                //             active: false,
                //             color: '#2a4351'
                //         }
                //     }
                // }
            }
        },


        fansTableData: {

            params_table: {

                pressure: {
                    type: 'from_to',
                    unit: [
                        'Pa',
                        'Bar'
                    ],
                    selected: 'Pa',
                    title: 'Ciśnienie',
                    infinityMin: true,
                    infinityMax: true,
                    method_of_filtering: "",
                    range_from: '4800',
                    range_to: '6000'
                },

                efficiency: {
                    type: 'from_to',
                    unit: [
                        'Pa',
                        'Bar'
                    ],
                    selected: 'Pa',
                    title: 'Wydajność',
                    range_from: '4800',
                    range_to: '6000'
                },

                temperature: {
                    type: 'plus_minus',
                    unit: [
                        'C',
                        'W'
                    ],
                    selected: 'C',
                    title: 'Temperatura',
                    range_from: '-20',
                    range_to: '+80'
                },


                power_on_the_shaft: {
                    type: 'from_to',
                    unit: [
                        'kW',
                        'W'
                    ],
                    selected: 'kW',
                    title: 'Moc na wale',
                    range_from: '4800',
                    range_to: '6000'
                },

                power_on_the_shaft1: {
                    type: 'from_to',
                    unit: [
                        'kW',
                        'W'
                    ],
                    selected: 'kW',
                    title: 'Moc na wale1',
                    range_from: '4800',
                    range_to: '6000'
                },

                pressure1: {
                    type: 'from_to',
                    unit: [
                        'Pa',
                        'Bar'
                    ],
                    selected: 'Pa',
                    title: 'Ciśnienie1',
                    range_from: '4800',
                    range_to: '6000'
                },

                efficiency1: {
                    type: 'from_to',
                    unit: [
                        'Pa',
                        'Bar'
                    ],
                    selected: 'Pa',
                    title: 'Wydajność1',
                    range_from: '4800',
                    range_to: '6000'
                },

                temperature1: {
                    type: 'plus_minus',
                    unit: [
                        'C',
                        'F'
                    ],
                    selected: 'C',
                    title: 'Temperatura1',
                    range_from: '-20',
                    range_to: '+80'
                },

                temperature2: {
                    type: 'plus_minus',
                    unit: [
                        'C',
                        'F'
                    ],
                    selected: 'C',
                    title: 'Temperatura2',
                    range_from: '-20',
                    range_to: '+80'
                },

                position: {
                    type: 'text',
                    title: 'Pozycja',
                    selected: 'wszystkie'
                },
            },

            fans_table: [

                // {
                //     data: null,
                //     id: 0,
                //     type: 'TS-EN',
                //     model: '09/100/56/01',
                //     imgSrc: "/gfx/imgs/do_czystego_powietrza.png",
                //     isActive: true,
                //     isCompared: false,
                //     engine: null,
                //     params: {
                //         price: 5,
                //         installed_power: 150,
                //         performance: -200,
                //         casing_dimensions: 'latająca'
                //     }
                // },
                //
                // {
                //     id: 1,
                //     type: 'TS-EN',
                //     model: '09/100/56/02',
                //     imgSrc: "/gfx/imgs/do_czystego_powietrza.png",
                //     isActive: false,
                //     isCompared: false,
                //     engine: null,
                //     params: {
                //         price: 11,
                //         installed_power: 300,
                //         performance: -1,
                //         casing_dimensions: 'stojąca'
                //     }
                // },
                //
                // {
                //     id: 2,
                //     type: 'TS-EN',
                //     model: '09/100/56/04',
                //     imgSrc: "/gfx/imgs/do_czystego_powietrza.png",
                //     isActive: false,
                //     isCompared: false,
                //     engine: null,
                //     params: {
                //         price: 200,
                //         installed_power: 100,
                //         performance: 20,
                //         casing_dimensions: 'paseratti'
                //     }
                // },
                //
                // {
                //     id: 3,
                //     type: 'TS-EN',
                //     model: '09/100/56/05',
                //     imgSrc: "/gfx/imgs/do_czystego_powietrza.png",
                //     isActive: false,
                //     isCompared: false,
                //     engine: null,
                //     params: {
                //         price: 124,
                //         installed_power: 120,
                //         performance: 100,
                //         casing_dimensions: 'leżąca'
                //     }
                // }
            ],

            customSorting: {},
            customFilters: [],

        },

        accessories: {
            fan_price: 1000,
            sumAdditionalAccessoriesPrice: Number,
            additional_accessories: {},

            included_accessories: {},


            // input_names: {
            //     32: {title: "Kolor RAL obudowy*"},
            //     52: {title: "Kolor RAL silnika*"},
            //     72: {title: "Kolor RAL obudowy*"},
            //     92: {title: "Kolor RAL obudowy*"},
            //     13: {title: "Kolor RAL obudowy*"},
            // }
        },

        defaultManufacturer: null,
        enginesList: [],
        atexesList: [],
        fansVersionsList: [],
        pricesList: [],
        relationsFanAtexes: [],
        relationsVersionsExtras: [],
        fansExtrasList: [],
        reloadFansTableSetting: true,
        appMaterialSortList: [],
        appPathsList: [],
        appFanSortsList: [],
        appPathsFanTypesList: [],
        appPathsParametersSettingsList: [],
        appTableParametersSettingsList: [],
        appPathsWorkPointsSettingsList: [],
        appMeasurementsList: [],
        appCharacteristicsList: [],
        appFansImagesList: [],
        FansTypesList: [],
        ConnectionsList: [],
        EngineStartupList: [],
        OctaveNoiseList: [],
        unitsList: [],
        fansOfPath: [],
        selectedFan: null,
        selectFanHandler: 0,
        setWorkPointWhenFanHandlerFired: false,

        graphMeshSettings: {x: {step: 60}, y: {step: 50}},

        fourthStepParamsLastUnitChanges: {
            userChanged: false,
            unit: null,
            param_id: null,
            unitType: null,
            subId: null
        },

        productCard: {
            savedWorkPoint: null,
            paramsFlipped: false,
            workPointInitialLoaded: false,
            loaded: false,
            custom: {

                id_offer_temp: '-',
                id_offer_received: '-',
                version: 0,

                basic: {

                    values: {

                        client: {
                            title: 'client',
                            value: '-'
                        },

                        prepared_by: {
                            title: 'prepared_by',
                            value: '-'
                        },

                        commission: {
                            title: 'commission',
                            value: '-'
                        },

                        creation_date: {
                            title: 'creation_date',
                            value: '-'
                        },

                        project_number: {
                            title: 'project_number',
                            value: '-'
                        },

                        // NVS-148
                        // comment: {
                        //     title: 'comment',
                        //     value: '-'
                        // },

                    }
                },

                connections: {
                    view: false,
                    title: 'connections', //do tłumaczenia
                    schema_title: 'schema_connection', //do tłumaczenia
                    values: {
                        suction: {
                            isDisabled: true,
                            title: 'suction_connection', //do tłumaczenia
                            image: '',
                            diameter: '',
                            outlet_a: '',
                            outlet_b: '',
                            norm: ''
                        },
                        pressing: {
                            isDisabled: true,
                            title: 'pressing_connection', //do tłumaczenia
                            image: '',
                            diameter: '',
                            outlet_a: '',
                            outlet_b: '',
                            norm: ''
                        }
                    }
                },

                fan: {

                    title: 'fan',
                    values: {

                        fan_genre: {
                            title: 'fan_genre',
                            value: '-',
                            translation: true
                        },

                        fan_type: {
                            title: 'fan_type',
                            value: '-'
                        },

                        type_number: {
                            title: 'fan_type_number',
                            value: '-'
                        },

                        fan_position: {
                            title: 'fan_position',
                            value: '-'
                        },

                        transition_on_suction: {
                            title: 'transition_on_suction',
                            value: '-',
                            isDisabled: true
                        },

                        transition_on_pressing: {
                            title: 'transition_on_pressing',
                            value: '-',
                            isDisabled: true
                        },

                        default_suction_connection_type: {
                            title: 'default_suction_connection_type',
                            value: '-',
                            variable: true,
                            isDisabled: true
                        },

                        default_pressing_connection_type: {
                            title: 'default_pressing_connection_type',
                            value: '-',
                            variable: true,
                            isDisabled: true
                        },

                        execution: {
                            title: 'execution',
                            value: '-',
                            variable: true
                        },

                        medium: {
                            title: 'medium',
                            value: '-',
                            translation: true
                        },

                        rotor: {
                            title: 'rotor',
                            value: '-',
                            translation: true
                        },

                        drive: {
                            title: 'drive',
                            value: '-',
                            translation: true
                        },

                        weight_class: {
                            title: 'weight_class',
                            value: '-',
                            variable: true
                        },

                        number_of_fans: {
                            title: 'number_of_fans',
                            value: '-'
                        },

                        additional_info: {
                            title: 'additional_info',
                            value: '-',
                            variable: true
                        }
                    }

                },

                input_data: {
                    title: 'input_data',
                    values: {}
                },

                work_parameters: {
                    title: 'work_parameters',
                    values: {}
                },

                accesories: {
                    sumAdditionalAccessoriesPrice: 0,
                    isStored: false,
                    title: "accessories",
                    values: {
                        add_accessories: {
                            title: "additional_accessories",
                            values: {}
                        },

                        included_accessories: {
                            title: "included_accessories",
                            values: {}
                        }
                    }
                },

                engine: {
                    title: 'engine',
                    values: {

                        producer: {
                            title: 'producer',
                            value: '-'
                        },

                        motor_poles: {
                            title: 'motor_poles',
                            value: '-'
                        },

                        rated_speed: {
                            title: 'rated_speed',
                            value: '-'
                        },

                        rated_power: {
                            title: 'rated_power',
                            value: '-'
                        },

                        motor_designation: {
                            title: 'motor_designation',
                            value: '-'
                        },

                        frequency: {
                            title: 'frequency',
                            value: '-'
                        },

                        rated_voltage: {
                            title: 'rated_voltage',
                            value: '-'
                        },

                        protection_class: {
                            title: 'protection_class',
                            value: '-',
                        },

                        thermal_class: {
                            title: 'thermal_class',
                            value: '-',
                            variable: true
                        },

                        efficiency_class: {
                            title: 'efficiency_class',
                            value: '-',
                        },

                        winding_protection: {
                            title: 'winding_protection',
                            value: '-',
                            variable: true
                        },

                        reinforced_bearings: {
                            title: 'reinforced_bearings',
                            value: '-',
                            variable: true
                        },

                        special_version: {
                            title: 'special_version',
                            value: '-',
                            variable: true
                        },

                        work_on_inverter_possibility: {
                            title: 'work_on_inverter_possibility',
                            value: 'yes'
                        }
                    }
                },

                execution: {
                    title: 'atex_execution',
                    inside_header: 'inside',
                    outside_header: 'outside',
                    inside_suffix: '_inside',
                    outside_suffix: '_outside',
                    values: {
                        zone: {
                            title: "zone",
                            inside_value: '-',
                            outside_value: '-',
                            inside_edit: false,
                            outside_edit: false
                        },
                        /* NVS-116
                        explosion_category: {
                            title: "explosion_category",
                            inside_value: '-',
                            outside_value: '-',
                            inside_edit: false,
                            outside_edit: false
                        },

                        device_category: {
                            title: "device_category",
                            inside_value: '-',
                            outside_value: '-',
                            inside_edit: false,
                            outside_edit: false
                        },

                        anti_explosion_protection_type: {
                            title: "anti_explosion_protection_type",
                            inside_value: '-',
                            outside_value: '-',
                            inside_edit: false,
                            outside_edit: false
                        },

                        temperature_class: {
                            title: "temperature_class",
                            inside_value: '-',
                            outside_value: '-',
                            inside_edit: false,
                            outside_edit: false
                        },
                        */
                        ex_signature: {
                            title: "ex_signature",
                            inside_value: '-',
                            outside_value: '-'
                        },
                    },
                },

                corrosion_protection: {
                    title: 'corrosion_protection',
                    values: {

                        class_category: {
                            title: 'class_category',
                            value: '-',
                            submenu: true,
                            connectedKey: 'coating_thickness',
                        },
                        /* NVS-152
                        underlay: {
                            title: 'underlay',
                            value: '-',
                            variable: true
                        },

                        coating: {
                            title: 'coating',
                            value: 'Powłoka lakiernicza',
                            variable: true
                        },
                        */
                        underlay_thickness: {
                            title: 'underlay_thickness',
                            value: '-',
                        },

                        coating_thickness: {
                            title: 'coating_thickness',
                            value: '-',
                        },

                        fan_cover_color: {
                            title: 'fan_cover_color',
                            value: '-'
                        },

                        fan_color_rest: {
                            title: 'fan_color_rest',
                            value: '-'
                        },

                        fan_engine_color: {
                            title: 'fan_engine_color',
                            value: '-'
                        },

                    }
                },

                work_restrictions: {
                    title: 'work_restrictions',
                    inside_header: 'minimum',
                    outside_header: 'maximum',
                    values: {
                        material_temperature: {
                            title: "material_temperature",
                            inside_value: '-',
                            outside_value: '-'
                        },

                        ambient_temperature: {
                            title: "ambient_temperature",
                            inside_value: '-',
                            outside_value: '-'
                        },

                        rotor_speed: {
                            title: "rotor_speed",
                            inside_value: '-',
                            outside_value: '-'
                        }
                    }
                },

                summary: {
                    title: 'valuation',
                    values: {
                        fan: {
                            title: '',
                            value: '',
                        },
                    },
                    discounts: {
                        
                    }
                },

                //NVS-148
                comment: {
                    title: 'comment',
                    value: '-'
                },

                delivery: {
                    title: 'delivery_and_additional_info',
                    values: {

                        delivery_time: {
                            title: 'delivery_time',
                            value: '-',
                            variable: true,
                        },

                        delivery_expiration_date: {
                            title: 'delivery_expiration_date',
                            value: '-',
                            variable: true,
                        }

                    }
                },

                variables: {},

                summary_form: {}

            },
            null_custom: {

                id_offer_temp: '-',
                id_offer_received: '-',
                version: 0,

                basic: {

                    values: {

                        client: {
                            title: 'client',
                            value: '-'
                        },

                        prepared_by: {
                            title: 'prepared_by',
                            value: '-'
                        },

                        commission: {
                            title: 'commission',
                            value: '-'
                        },

                        creation_date: {
                            title: 'creation_date',
                            value: '-'
                        },

                        project_number: {
                            title: 'project_number',
                            value: '-'
                        },

                        // NVS-148
                        // comment: {
                        //     title: 'comment',
                        //     value: '-'
                        // },

                    }
                },

                connections: {
                    view: false,
                    title: 'connections',
                    schema_title: 'schema_connection',
                    values: {
                        suction: {
                            isDisabled: true,
                            title: 'suction_connection',
                            image: '',
                            diameter: '',
                            outlet_a: '',
                            outlet_b: '',
                            norm: ''
                        },
                        pressing: {
                            isDisabled: true,
                            title: 'pressing_connection',
                            image: '',
                            diameter: '',
                            outlet_a: '',
                            outlet_b: '',
                            norm: ''
                        }
                    }
                },

                fan: {

                    title: 'fan',
                    values: {

                        fan_genre: {
                            title: 'fan_genre',
                            value: '-',
                            translation: true
                        },

                        fan_type: {
                            title: 'fan_type',
                            value: '-'
                        },

                        type_number: {
                            title: 'fan_type_number',
                            value: '-'
                        },

                        fan_position: {
                            title: 'fan_position',
                            value: '-'
                        },

                        transition_on_suction: {
                            title: 'transition_on_suction',
                            value: '-',
                            isDisabled: true
                        },

                        transition_on_pressing: {
                            title: 'transition_on_pressing',
                            value: '-',
                            isDisabled: true
                        },

                        default_suction_connection_type: {
                            title: 'default_suction_connection_type',
                            value: '-',
                            variable: true,
                            isDisabled: true
                        },

                        default_pressing_connection_type: {
                            title: 'default_pressing_connection_type',
                            value: '-',
                            variable: true,
                            isDisabled: true
                        },

                        execution: {
                            title: 'execution',
                            value: '-',
                            variable: true
                        },

                        medium: {
                            title: 'medium',
                            value: '-',
                            translation: true
                        },

                        rotor: {
                            title: 'rotor',
                            value: '-',
                            translation: true
                        },

                        drive: {
                            title: 'drive',
                            value: '-',
                            translation: true
                        },

                        weight_class: {
                            title: 'weight_class',
                            value: '-',
                            variable: true
                        },

                        number_of_fans: {
                            title: 'number_of_fans',
                            value: '-'
                        },

                        additional_info: {
                            title: 'additional_info',
                            value: '-',
                            variable: true
                        }
                    }

                },

                input_data: {
                    title: 'input_data',
                    values: {}
                },

                work_parameters: {
                    title: 'work_parameters',
                    values: {}
                },

                accesories: {
                    sumAdditionalAccessoriesPrice: 0,
                    isStored: false,
                    title: "accessories",
                    values: {
                        add_accessories: {
                            title: "additional_accessories",
                            values: {}
                        },

                        included_accessories: {
                            title: "included_accessories",
                            values: {}
                        }
                    }
                },

                engine: {
                    title: 'engine',
                    values: {

                        producer: {
                            title: 'producer',
                            value: '-'
                        },

                        motor_poles: {
                            title: 'motor_poles',
                            value: '-'
                        },

                        rated_speed: {
                            title: 'rated_speed',
                            value: '-'
                        },

                        rated_power: {
                            title: 'rated_power',
                            value: '-'
                        },

                        motor_designation: {
                            title: 'motor_designation',
                            value: '-'
                        },

                        frequency: {
                            title: 'frequency',
                            value: '-'
                        },

                        rated_voltage: {
                            title: 'rated_voltage',
                            value: '-'
                        },

                        protection_class: {
                            title: 'protection_class',
                            value: '-',
                            // variable: true
                        },

                        thermal_class: {
                            title: 'thermal_class',
                            value: '-',
                            variable: true
                        },

                        efficiency_class: {
                            title: 'efficiency_class',
                            value: '-',
                        },

                        winding_protection: {
                            title: 'winding_protection',
                            value: '-',
                            variable: true
                        },

                        reinforced_bearings: {
                            title: 'reinforced_bearings',
                            value: '-',
                            variable: true
                        },

                        special_version: {
                            title: 'special_version',
                            value: '-',
                            variable: true
                        },

                        work_on_inverter_possibility: {
                            title: 'work_on_inverter_possibility',
                            value: 'yes'
                        }
                    }
                },

                execution: {
                    title: 'atex_execution',
                    inside_header: 'inside',
                    outside_header: 'outside',
                    inside_suffix: '_inside',
                    outside_suffix: '_outside',
                    values: {
                        zone: {
                            title: "zone",
                            inside_value: '-',
                            outside_value: '-'
                        },

                        /*
                        NVS-116
                        explosion_category: {
                            title: "explosion_category",
                            inside_value: '-',
                            outside_value: '-'
                        },

                        device_category: {
                            title: "device_category",
                            inside_value: '-',
                            outside_value: '-'
                        },

                        anti_explosion_protection_type: {
                            title: "anti_explosion_protection_type",
                            inside_value: '-',
                            outside_value: '-'
                        },

                        temperature_class: {
                            title: "temperature_class",
                            inside_value: '-',
                            outside_value: '-'
                        },
                        */

                        ex_signature: {
                            title: "ex_signature",
                            inside_value: '-',
                            outside_value: '-'
                        }
                    },
                },

                corrosion_protection: {
                    title: 'corrosion_protection',
                    values: {

                        class_category: {
                            title: 'class_category',
                            value: '-',
                            submenu: true,
                            connectedKey: 'coating_thickness',
                        },
                        /* NVS-152
                        underlay: {
                            title: 'underlay',
                            value: '-',
                            variable: true
                        },

                        coating: {
                            title: 'coating',
                            value: 'Powłoka lakiernicza',
                            variable: true
                        },
                        */
                        underlay_thickness: {
                            title: 'underlay_thickness',
                            value: '-',
                        },

                        coating_thickness: {
                            title: 'coating_thickness',
                            value: '-',
                        },

                        fan_cover_color: {
                            title: 'fan_cover_color',
                            value: '-'
                        },

                        fan_color_rest: {
                            title: 'fan_color_rest',
                            value: '-'
                        },

                        fan_engine_color: {
                            title: 'fan_engine_color',
                            value: '-'
                        },

                    }
                },

                work_restrictions: {
                    title: 'work_restrictions',
                    inside_header: 'minimum',
                    outside_header: 'maximum',
                    values: {
                        material_temperature: {
                            title: "material_temperature",
                            inside_value: '-',
                            outside_value: '-'
                        },

                        ambient_temperature: {
                            title: "ambient_temperature",
                            inside_value: '-',
                            outside_value: '-'
                        },

                        rotor_speed: {
                            title: "rotor_speed",
                            inside_value: '-',
                            outside_value: '-'
                        }
                    }
                },

                summary: {
                    title: 'valuation',
                    values: {
                        fan: {
                            title: '',
                            value: '',
                        },
                    }
                },

                //NVS-148
                comment: {
                    title: 'comment',
                    value: '-'
                },

                delivery: {
                    title: 'delivery_and_additional_info',
                    values: {

                        delivery_time: {
                            title: 'delivery_time',
                            value: '-',
                            variable: true,
                        },

                        delivery_expiration_date: {
                            title: 'delivery_expiration_date',
                            value: '-',
                            variable: true,
                        }

                    }
                },

                variables: {},

                summary_form: {}

            },
        },

        ValueUnitMap: {
            "performance": {value: "performance", units: [], selected: null},
            "temperature": {value: "temperature", units: [], selected: null},
            "minimum_air_amount": {value: "performance", units: [], selected: null},
            "minimum_amount_of_air_at_the_minimum_frequency": {value: "performance", units: [], selected: null},
            "materialAmount": {value: "materialAmount", units: [], selected: null},
            "density": {value: "density", units: [], selected: null},
            "air_density": {value: "density", units: [], selected: null},
            "pressure": {value: "pressure", units: [], selected: null},//Uzywane w punkcie pracy
            "total_pressure": {value: "pressure", units: [], selected: null},
            "static_pressure": {value: "pressure", units: [], selected: null},
            "static_pressure_increase": {value: "pressure", units: [], selected: null},
            "dynamic_pressure": {value: "pressure", units: [], selected: null},
            "efficiency": {value: "efficiency", units: [], selected: null},
            "total_efficiency": {value: "efficiency", units: [], selected: null},
            "static_efficiency": {value: "efficiency", units: [], selected: null},
            "engine_efficiency": {value: "efficiency", units: [], selected: null},
            "noise": {value: "noise", units: [], selected: null},
            "noise_lwa": {value: "noise", units: [], selected: null},
            "noise_lpa": {value: "noise", units: [], selected: null},
            "power_on_shaft": {value: "power", units: [], selected: null},
            "power_on_shaft_with_material": {value: "power", units: [], selected: null},
            "power": {value: "power", units: [], selected: null},
            "installed_power": {value: "power", units: [], selected: null},
            "electrical_power": {value: "power", units: [], selected: null},
            "electrical_power_with_material": {value: "power", units: [], selected: null},
            "current": {value: "current", units: [], selected: null},
            "amperage_v1": {value: "current", units: [], selected: null},
            "amperage_v2": {value: "current", units: [], selected: null},
            "material_amount": {value: "materialAmount", units: [], selected: null},
            "material_density": {value: "density", units: [], selected: null},
            "pipeline_average_speed": {value: "", units: [], selected: null},
            "characteristic_coefficient": {value: "", units: [], selected: null},
            "frequency": {value: "frequency", units: [], selected: null},
            "work_frequency": {value: "frequency", units: [], selected: null},
            "casing_dimensions": {value: "", units: [], selected: null},
            "mass": {value: "mass", units: [], selected: null},
            "weight": {value: "mass", units: [], selected: null},
            "number_of_fans": {value: "", units: [], selected: null},
            // "minimum_work_pressure": {value: "pressure", units: [], selected: null},
            "minimum_frequency_on_the_inverter": {value: "frequency", units: [], selected: null},
            "average_length_of_the_shredded_material": {value: "length", units: [], selected: null},
            "average_rated_speed_of_the_fan": {value: "", units: [], selected: null},
            "maximum_rotor_speed": {value: "", units: [], selected: null},
            "number_of_poles": {value: "", units: [], selected: null},
            "price": {value: "", units: [], selected: null},
            "drive": {value: "", units: [], selected: null},
            "rotor_type": {value: "", units: [], selected: null},
            "fan_type": {value: "-", units: [], selected: null},
            "fan_type_number": {value: "-", units: [], selected: null},
            "fan_graphics": {value: "-", units: [], selected: null},
            "length": {value: "length", units: [], selected: null},
            "pipeline_diameter": {value: "length", units: [], selected: null},
            "above_sea": {value: "length", units: [], selected: null},
            "fan_temperature_increase": {value: "temperature", units: [], selected: null},
            "max_medium_temperature": {value: "temperature", units: [], selected: null},
            "atmospheric_pressure": {value: "pressure", units: [], selected: null},
            "normal_performance": {value: "performance", units: [], selected: null},
            "calculated_performance": {value: "performance", units: [], selected: null},
            "calculated_pressure": {value: "pressure", units: [], selected: null},
        },

        comparison: {
            fans: [
                {
                    imgSrc: "/gfx/imgs/do_porownania.png",
                    title: "US-SFN",
                    serial_number: "09/56/369",
                    params: {
                        performance: {
                            title: 'Wydajność',
                            unit: 'm3/h',
                            value: 1
                        },

                        total_pressure: { /*cisnienie wyliczone w zaleznosc od tego co zostalo zaznaczone w parametrze np total lub static*/
                            title: 'Ciśnienie',
                            unit: 'Pa',
                            value: 3
                        },

                        power_on_shaft: {
                            title: 'Moc na wale',
                            unit: 'kW',
                            value: 5
                        },

                        power_on_shaft_with_material: {
                            title: 'Moc na wale z materialem',
                            unit: 'kW',
                            value: 5,
                            connected: "power_on_shaft"
                        },

                        engine_efficiency: {
                            title: "Sprawnosc silnika",
                            unit: "-",
                            value: 9
                        }
                    }
                },

                {
                    imgSrc: "/gfx/imgs/tnące.png",
                    title: "US-SFN",
                    serial_number: "09/56/369",
                    params: {
                        performance: {
                            title: 'Wydajność',
                            unit: 'm3/h',
                            value: 1
                        },

                        total_pressure: { /*cisnienie wyliczone w zaleznosc od tego co zostalo zaznaczone w parametrze np total lub static*/
                            title: 'Ciśnienie',
                            unit: 'Pa',
                            value: 3
                        },

                        power_on_shaft: {
                            title: 'Moc na wale',
                            unit: 'kW',
                            value: 5
                        },

                        power_on_shaft_with_material: {
                            title: 'Moc na wale z materialem',
                            unit: 'kW',
                            value: 5,
                            connected: "power_on_shaft"
                        },

                        engine_efficiency: {
                            title: "Sprawnosc silnika",
                            unit: "-",
                            value: 9
                        }
                    }
                }
            ]
        },

        fanMaterials: {
            with_materials: [
                {
                    title: "US-SFN",
                    params: {
                        day: {
                            title: 'day',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 5,
                            currency_value: 1000
                        },

                        month: {
                            title: 'month',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 50,
                            currency_value: 1500
                        },

                        year: {
                            title: 'year',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 500,
                            currency_value: 2000
                        }
                    }
                },

                {
                    title: "US-SFNNN",
                    params: {
                        day: {
                            title: 'day',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 5,
                            currency_value: 1000
                        },

                        month: {
                            title: 'month',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 50,
                            currency_value: 1500
                        },

                        year: {
                            title: 'year',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 500,
                            currency_value: 2000
                        }
                    }
                }
            ],

            without_materials: [
                {
                    title: "US-SFN",
                    params: {
                        day: {
                            title: 'day',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 12,
                            currency_value: 200
                        },

                        month: {
                            title: 'month',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 20,
                            currency_value: 790
                        },

                        year: {
                            title: 'year',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 30,
                            currency_value: 1300
                        }
                    }
                },

                {
                    title: "US-SFNNN",
                    params: {
                        day: {
                            title: 'day',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 12,
                            currency_value: 200
                        },

                        month: {
                            title: 'month',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 20,
                            currency_value: 790
                        },

                        year: {
                            title: 'year',
                            unit: 'kW',
                            currency: 'zl',
                            unit_value: 30,
                            currency_value: 1300
                        }
                    }
                }
            ]
        },

        offers: {
            fans: [
                {
                    params: {
                        name: {
                            header: "Nazwa",
                            value: "TS-EN",
                        },

                        date: {
                            header: "Data",
                            value: "20/08/2019",
                        },

                        selection_number: {
                            header: "Numer doboru",
                            value: "09/100/56/01",
                        },

                        status: {
                            header: "Status",
                            value: "status",
                        },

                        network_frequency: {
                            header: "Częstotliwość sieci",
                            value: 50
                        },

                        electricity: {
                            header: "Prąd",
                            value: 123
                        },

                        pressure: {
                            header: "Ciśnienie",
                            value: 4531
                        },

                        efficiency: {
                            header: "Wydajnosc",
                            value: 24
                        },

                        height_above_sea_level: {
                            header: "Wysokosc n.p.m",
                            value: 1500
                        },

                        temperature: {
                            header: "Temperatura",
                            value: 56
                        },

                        pipeline_diameter: {
                            header: "Średnica rurociagu",
                            value: 200
                        },

                        work_on_the_inverter: {
                            header: "Praca na falowniku",
                            value: 350
                        }
                    }
                },

                {
                    params: {
                        name: {
                            header: "Nazwa",
                            value: "TS-EN",
                        },

                        date: {
                            header: "Data",
                            value: "20/08/2019",
                        },

                        selection_number: {
                            header: "Numer doboru",
                            value: "09/100/56/01",
                        },

                        status: {
                            header: "Status",
                            value: "status",
                        },

                        network_frequency: {
                            header: "Częstotliwość sieci",
                            value: 50
                        },

                        electricity: {
                            header: "Prąd",
                            value: 123
                        },

                        pressure: {
                            header: "Ciśnienie",
                            value: 4531
                        },

                        efficiency: {
                            header: "Wydajnosc",
                            value: 24
                        },

                        height_above_sea_level: {
                            header: "Wysokosc n.p.m",
                            value: 1500
                        },

                        temperature: {
                            header: "Temperatura",
                            value: 56
                        },

                        pipeline_diameter: {
                            header: "Średnica rurociagu",
                            value: 200
                        },

                        work_on_the_inverter: {
                            header: "Praca na falowniku",
                            value: 350
                        }
                    }

                },

                {
                    params: {
                        name: {
                            header: "Nazwa",
                            value: "TS-EN",
                        },

                        date: {
                            header: "Data",
                            value: "20/08/2019",
                        },

                        selection_number: {
                            header: "Numer doboru",
                            value: "09/100/56/01",
                        },

                        status: {
                            header: "Status",
                            value: "status",
                        },

                        network_frequency: {
                            header: "Częst. sieci",
                            value: 50
                        },

                        electricity: {
                            header: "Prąd",
                            value: 123
                        },

                        pressure: {
                            header: "Ciśnienie",
                            value: 4531
                        },

                        efficiency: {
                            header: "Wydajnosc",
                            value: 24
                        },

                        height_above_sea_level: {
                            header: "Wysokosc n.p.m",
                            value: 1500
                        },

                        temperature: {
                            header: "Temperatura",
                            value: 56
                        },

                        pipeline_diameter: {
                            header: "Śr. rurociagu",
                            value: 200
                        },

                        work_on_the_inverter: {
                            header: "Praca na falowniku",
                            value: 350
                        }
                    }
                },
                {
                    params: {
                        name: {
                            header: "Nazwa",
                            value: "TS-EN-TS",
                        },

                        date: {
                            header: "Data",
                            value: "20/08/2019",
                        },

                        selection_number: {
                            header: "Numer doboru",
                            value: "09/100/56/01",
                        },

                        status: {
                            header: "Status",
                            value: "status",
                        },

                        network_frequency: {
                            header: "Częstotliwość sieci",
                            value: 43210
                        },

                        electricity: {
                            header: "Prąd",
                            value: 98765
                        },

                        pressure: {
                            header: "Ciśnienie",
                            value: 499999
                        },

                        efficiency: {
                            header: "Wydajnosc",
                            value: 240
                        },

                        height_above_sea_level: {
                            header: "Wysokosc n.p.m",
                            value: 150345
                        },

                        temperature: {
                            header: "Temperatura",
                            value: 1123
                        },

                        pipeline_diameter: {
                            header: "Średnica rurociagu",
                            value: 2333
                        },

                        work_on_the_inverter: {
                            header: "Praca na falowniku",
                            value: 1232131
                        }
                    }
                },
            ]
        }
    },

    mutations: {
        changeGridSetting(state, payload) {
            // Vue.set(state.graphMeshSettings.x.step,payload.x);
            // Vue.set(state.graphMeshSettings.y.step,payload.y);
            state.graphMeshSettings = {x: {step: payload.x}, y: {step: payload.y}};
        },
        filterAllColumn(state) {
            for (let param_id in state.fansTableData.params_table) {
                if (state.fansTableData.params_table.hasOwnProperty(param_id)) {
                    if (param_id === "drive") continue;
                    this.commit('FansTable/SET_CUSTOM_FILTER', {filter: param_id, value: "-"});
                }
            }
        },
        manageSelectedFan(state) {
            let selectedFan = state.fansTableData.fans_table.filter(x => x.isActive == true);

            if (selectedFan && selectedFan.length > 0)
                selectedFan = selectedFan[0];
            else
                selectedFan = null;

            if (state.fansTableData.FanTableRef && state.fansTableData.FanTableRef.allFilteredData && state.fansTableData.FanTableRef.allFilteredData.length > 0) {
                let selectedFanIsInFilteredData = false;

                if (selectedFan) {
                    for (let filteredFan of state.fansTableData.FanTableRef.allFilteredData) {
                        if (filteredFan.id == selectedFan.id) {
                            selectedFanIsInFilteredData = true;
                            state.selectedFan = selectedFan.data;
                            return;
                        }
                    }
                }

                if (!selectedFanIsInFilteredData) {
                    this.commit({
                        type: 'selectFanRowAsActiveInFansTable',
                        fan_id: state.fansTableData.FanTableRef.allFilteredData[0].id,
                    });

                    return;
                }
            } else {
                if (selectedFan && selectedFan.hasOwnProperty("isActive")) {
                    state.isActive = false;
                    state.selectedFan = null;
                }
            }
        },
        generateFilteringMethods(state) {
            state.fansTableData.customFilters = [];

            for (let param_id in state.fansTableData.params_table) {

                if (state.fansTableData.params_table.hasOwnProperty(param_id)) {
                    let param = state.fansTableData.params_table[param_id];

                    let filter = {
                        name: param_id,
                        callback: function (row, query) {
                            if (param.type == "from_to") {
                                let option = {elements: {1: state.ValueUnitMap[param_id].selected}};
                                let paramFrom = {value: param.range_from};
                                let paramTo = {value: param.range_to};
                                let curentValue = {value: row.params[param_id]};

                                let argFrom = {
                                    type: 'calcUnit',
                                    param: paramFrom,
                                    option: option,
                                    out: ""
                                }

                                let argTo = {
                                    type: 'calcUnit',
                                    param: paramTo,
                                    option: option,
                                    out: ""
                                }

                                let argCurent = {
                                    type: 'calcUnit',
                                    param: curentValue,
                                    option: option,
                                    out: ""
                                }

                                this.commit(argFrom);
                                this.commit(argTo);
                                this.commit(argCurent);


                                let FromValue = parseFloat(argFrom.out);
                                let ToValue = parseFloat(argTo.out);
                                let CurentValue = parseFloat(argCurent.out);

                                return (param.infinityMin == 1 || CurentValue >= FromValue) &&
                                    (param.infinityMax == 1 || CurentValue <= ToValue);
                            } else if (param.type == "plus_minus") {
                                let requestedParamId = param_id;

                                if (requestedParamId.endsWith("pressure")) {
                                    requestedParamId = "pressure";
                                }

                                if (requestedParamId == "max_medium_temperature") {
                                    requestedParamId = "temperature";
                                }

                                let stepParam = state.fourthStepParametersSelected[requestedParamId];

                                if (!stepParam)
                                    stepParam = state.fourthStepParameters[requestedParamId];

                                let option = {elements: {1: state.ValueUnitMap[param_id].selected}};
                                let paramSrc = {value: stepParam.value};
                                let paramFrom = {value: param.range_from};
                                let paramTo = {value: param.range_to};
                                let curentValue = {value: row.params[param_id]};

                                // NVS-92 - trzymanie początkowej wartości temperatury z doboru, żeby nie odfiltrowywał wentylatorów gdy przeciągana jest temperatura
                                // if (requestedParamId == "temperature" && state.fourthStepParameters.temperature.oryginal) {
                                //     paramSrc = {value: state.fourthStepParameters.temperature.oryginal};
                                //     curentValue = {value: state.fourthStepParameters.temperature.oryginal};
                                // }

                                let arg = {
                                    type: 'calcUnit',
                                    param: paramSrc,
                                    option: option,
                                    out: ""
                                }

                                let argFrom = {
                                    type: 'calcUnit',
                                    param: paramFrom,
                                    option: option,
                                    out: ""
                                }

                                let argTo = {
                                    type: 'calcUnit',
                                    param: paramTo,
                                    option: option,
                                    out: ""
                                }

                                let argCurent = {
                                    type: 'calcUnit',
                                    param: curentValue,
                                    option: option,
                                    out: ""
                                }

                                this.commit(arg);
                                this.commit(argFrom);
                                this.commit(argTo);
                                this.commit(argCurent);

                                let sourceValue = parseFloat(arg.out);
                                let FromValue = parseFloat(argFrom.out);
                                let ToValue = parseFloat(argTo.out);
                                let CurentValue = parseFloat(argCurent.out);

                                return (param.infinityMin == 1 || CurentValue >= sourceValue - FromValue) &&
                                    (param.infinityMax == 1 || CurentValue <= sourceValue + ToValue);
                            } else if (param.type == "text") {
                                return (query == "-" || row.params[param_id] == query)
                            }
                        }.bind(this)
                    }

                    state.fansTableData.customFilters.push(filter);
                }
            }
        }
        ,

        generateSortingMethod(state) {

            for (let param_id in state.fansTableData.params_table) {

                if (state.fansTableData.params_table.hasOwnProperty(param_id)) {
                    let param = state.fansTableData.params_table[param_id];

                    switch (param.type) {
                        case 'from_to' :

                            state.fansTableData.customSorting[param_id] = function (ascending) {
                                return function (a, b) {

                                    var lastA = a.params[param_id];
                                    var lastB = b.params[param_id];

                                    if (ascending)
                                        return lastA >= lastB ? -1 : 1;

                                    return lastA <= lastB ? -1 : 1;
                                }
                            };

                            break;

                        case 'plus_minus' :

                            state.fansTableData.customSorting[param_id] = function (ascending) {
                                return function (a, b) {

                                    var lastA = a.params[param_id];
                                    var lastB = b.params[param_id];

                                    if (ascending)
                                        return lastA >= lastB ? 1 : -1;

                                    return lastA <= lastB ? 1 : -1;
                                }
                            };

                            break;

                        case 'text' :

                            state.fansTableData.customSorting[param_id] = function (ascending) {

                                return function (a, b) {

                                    var lastA = a.params[param_id].toLowerCase();
                                    var lastB = b.params[param_id].toLowerCase();

                                    if (ascending)
                                        return lastA >= lastB ? 1 : -1;

                                    return lastA <= lastB ? 1 : -1;
                                }
                            };

                            break;

                        default:
                            break;
                    }
                }
            }
        },


        toggleAdjustResultBtn(state, payload) {
            state.isAdjustResultDisabled = payload.disabled
        },

        changeSelectedInParamsTable(state, payload) {

            let params_table = state.fansTableData.params_table;
            if (params_table[payload.param_id]) {
                params_table[payload.param_id].selected = payload.selected;
            }
        },
        changeSelectedUnitInValueUnitMap(state, payload) {
            let unitChanged = null;
            let unitType = "";
            let unitId = null;

            for (let unitElementId in state.ValueUnitMap) {
                if (state.ValueUnitMap.hasOwnProperty(unitElementId) && state.ValueUnitMap[unitElementId].value == state.ValueUnitMap[payload.param_id].value) {
                    for (let unit of state.ValueUnitMap[unitElementId].units) {
                        if ((payload.unitDescription && unit.value == payload.unitDescription) || (payload.unitId && unit.unit.id == payload.unitId)) {
                            Vue.set(unit, "active", true);
                            Vue.set(state.ValueUnitMap[unitElementId], "selected", unit);
                            unitChanged = unit.unit;
                            unitId = unit.unit.id;
                            unitType = state.ValueUnitMap[unitElementId].value;
                        } else
                            unit.active = false;
                    }
                }
            }

            let userChanged = true;

            if (payload.hasOwnProperty("userChanged") && payload.userChanged == false) {
                userChanged = false;
            }

            this.state.fourthStepParamsLastUnitChanges = {
                userChanged: userChanged,
                unit: unitChanged,
                param_id: unitType,
                unitType: unitType,
                subId: payload.param_id + "|" + unitId + "|" + unitType + "|" + userChanged,
            }
        }
        ,

        changeRangeFrom(state, payload) {

            let params_table = state.fansTableData.params_table;
            params_table[payload.param_id].range_from = payload.value
        },

        changeRangeTo(state, payload) {

            let params_table = state.fansTableData.params_table;
            params_table[payload.param_id].range_to = payload.value
        },


        selectFanRowForCompareInFansTable(state, payload) {

            let fanRows = state.fansTableData.fans_table;

            Object.keys(fanRows).forEach(function (id) {

                if (!fanRows[id].isCompared && (fanRows[id].id === payload.fan_id) && !fanRows[id].isActive) {

                    fanRows[id].isCompared = true;

                    this.commit({
                        type: 'setFunToCompare',
                        fanRow: fanRows[id],
                    });


                } else if (fanRows[id].isCompared && (fanRows[id].id !== payload.fan_id)) {

                    fanRows[id].isCompared = false;
                }
            }.bind(this));
        },

        selectFanRowAsActiveInFansTable(state, payload) {

            let fanRows = state.fansTableData.fans_table;

            // NVS-92 reset temperatury do tej z doboru
            if (state.fourthStepParameters.temperature && state.fourthStepParameters.temperature.oryginal) {
                state.fourthStepParameters.temperature.value = state.fourthStepParameters.temperature.oryginal
                state.fourthStepParametersSelected.temperature.value = state.fourthStepParameters.temperature.oryginal
            }

            Object.keys(fanRows).forEach(function (id) {

                if ((!fanRows[id].isActive || state.activeFun.count != payload.count) && (fanRows[id].id === payload.fan_id)) {

                    fanRows[id].isActive = true;
                    fanRows[id].isCompared = false;

                    state.selectedFan = fanRows[id].data;

                    let fanObj = {
                        type: 'setActiveFun',
                        fanRow: fanRows[id],
                        count: 1,
                        reset_params: payload.reset_params,
                    };

                    if (state.selectedSecondStepElement.multiple_fans == 1 && fanRows[id].data['number_of_fans'] && fanRows[id].data['number_of_fans'] > 0) {
                        fanObj.count = fanRows[id].data['number_of_fans'];
                    }

                    if (payload.count) {
                        fanObj.count = payload.count;
                    }

                    this.commit(fanObj);

                    state.selectFanHandler++;

                } else if (fanRows[id].isActive && (fanRows[id].id !== payload.fan_id)) {

                    fanRows[id].isActive = false;
                }
            }.bind(this));
        },

        toggleAdditionalAccessories(state, payload) {
            state.productCard.custom.accesories.values.add_accessories.values[payload.id].isActive = !state.productCard.custom.accesories.values.add_accessories.values[payload.id].isActive
            state.productCard.custom.accesories.values.add_accessories.values[payload.id].hidePrice = !state.productCard.custom.accesories.values.add_accessories.values[payload.id].isActive ? false : state.productCard.custom.accesories.values.add_accessories.values[payload.id].hidePrice
        },

        toggleIncludedAccessories(state, payload) {
            state.accessories.included_accessories[payload.id].isActive = !state.accessories.included_accessories[payload.id].isActive;
            state.productCard.custom.accesories.values.included_accessories.values[payload.id].hidePrice = false;
        },

        toggleProductCardsClient(state, payload) {
            state.productCards.basic[payload.id] = !state.productCards.basic[payload.id];
        },

        setActiveFun(state, payload) {

            if (payload.count)
                state.activeFun.count = payload.count;
            else
                state.activeFun.count = 1;

            if (payload.fanRow.id !== state.activeFun.id) {
                this.commit('resetSelectedFanAccessories');
            }

            state.activeFun = {
                ...payload.fanRow,
                params: payload.reset_params ? {...payload.fanRow.initial_params} : payload.fanRow.params,
                name: 'Wentylator',
                price: 0,
                src: payload.fanRow.imgSrc,
                selectedFanData: state.fansOfPath.find(x => x.id == payload.fanRow.id),
            };
        },

        // NVS-188
        resetLoadedOffer(state, payload) {
            console.log('resetting loaded offer');
            this.commit('resetOffer');
            state.activeFun = {
                id: 0,
                name: '-',
                type: '-',
                model: '-',
                price: 0,
                src: '-',
                suctionConnection: {},
                pressingConnection: {},
                engine: null,
                selectedFanData: null,
                data: null,
                count: 1,
            };
            state.selectedWorkPoint = null;
            state.discount.offerDiscountGivenByTheAdministrator = 0;
            // NVS-183 Usuwanie zapisanych filtrów dolnej tabeli z załadowanej oferty
            delete state.fansTableData.params_table_loaded;
        },

        resetOffer(state, payload) {
            //RESET ACCESSORIES IN CUSTOM CARD
            state.lastCalculationSelectedPressureType = null;

            state.discount.offerDiscountGivenByTheAdministrator = 0;
            state.discount.additionalDiscount = 0;
            state.productCard.custom.accesories.isStored = false;
            state.showPowerLine = false;

            //RESET GLOBAL LOCK FLAG
            state.productCard.loaded = false;
            state.globalInputLock = false;

            state.productCard.workPointInitialLoaded = false;
            state.productCard.savedWorkPoint = null;

            state.productCard.custom = JSON.parse(JSON.stringify(state.productCard.null_custom));
        },

        resetFansTable(state, payload) {
            while (state.fansTableData.fans_table.length > 0) {
                state.fansTableData.fans_table.pop();
            }

            state.reloadFansTableSetting = true;
            state.productCard.paramsFlipped = false;
        },

        resetOfferState(state, payload) {
            this.commit('resetOffer');
            this.commit('resetFansTable');
            this.commit('clearSelectedThirdStepElement');
            this.commit('cleanParamsValue');
            this.commit('cleanParamsValueCalc');
            this.commit('resetSelectedUnits');
        },

        resetSelectedFanAccessories(state, payload) {
            state.productCard.custom.accesories = JSON.parse(JSON.stringify(state.productCard.null_custom.accesories));
        },

        setFunToCompare(state, payload) {

            state.fanToCompare.id = payload.fanRow.id;
            state.fanToCompare.name = "Wentylator";
            state.fanToCompare.type = payload.fanRow.type;
            state.fanToCompare.model = payload.fanRow.model;
            state.fanToCompare.price = 0;
            state.fanToCompare.src = payload.fanRow.imgSrc;
            state.fanToCompare.data = payload.fanRow.data;
            state.fanToCompare.params = payload.fanRow.params;
            state.fanToCompare.engine = payload.fanRow.engine;
            state.fanToCompare.data = payload.fanRow.data;
            state.fanToCompare.selectedFanData = state.fansOfPath.find(x => x.id == payload.fanRow.id);
        },

        updateColorPartOfMainAxisParam(state, payload) {
            state.partsOfTheGraph.mainAxisParams[payload.param_id].specificParts[payload.specific_part_id].color = payload.color;
            state.partsOfTheGraphChanged++;
        },

        updateColorOfMainAxisParam(state, payload) {
            state.partsOfTheGraph.mainAxisParams[payload.param_id].color = payload.color;
            state.partsOfTheGraphChanged++;
        },

        updateSumAdditionalAccessories(state, payload) {
            state.accessories.additional_accessories[payload.id].price = payload.price;
        },


        selectMainAxisParam(state, payload) {

            let params = state.partsOfTheGraph.mainAxisParams;

            Object.keys(params[payload.param_id].specificParts).forEach(function (specific_part_id) {

                if (params[payload.param_id].specificParts[specific_part_id].active) {

                    state.partsOfTheGraph.mainAxisParams[payload.param_id].active = true;
                }
            });

            state.partsOfTheGraphChanged++;
        },

        clearMainAxisParams(state) {

            let params = state.partsOfTheGraph.mainAxisParams;

            Object.keys(params).forEach(function (id) {

                params[id].active = false;
            });

            state.partsOfTheGraphChanged++;
        },

        togglePartOfMainAxisParam(state, payload) {

            state.partsOfTheGraph.mainAxisParams[payload.param_id].specificParts[payload.specific_part_id].active = payload.isActive;
            state.partsOfTheGraphChanged++;
        },

        resetSelectedUnits(state) {
            let changedUnits = [];

            for (let unitSettings in state.ValueUnitMap) {
                if (state.ValueUnitMap[unitSettings].selected && state.ValueUnitMap[unitSettings].selected.unit && state.ValueUnitMap[unitSettings].selected.unit.flag_default != 1) {
                    if (!changedUnits.includes(state.ValueUnitMap[unitSettings].value)) {
                        let defaultUnit = state.ValueUnitMap[unitSettings].units.find(unit => unit.unit.flag_default == 1);

                        this.commit({
                            type: 'changeSelectedUnitInValueUnitMap',
                            param_id: unitSettings,
                            unitDescription: defaultUnit.value
                        });

                        changedUnits.push(state.ValueUnitMap[unitSettings].value);
                    }
                }
            }
        },

        cleanParamsValue(state) {

            let elementsObj = state.fourthStepParameters;

            // Object.keys(elementsObj).forEach(function (id) {
            //     typeof (elementsObj[id].value) !== 'undefined' ? (typeof (elementsObj[id].defaultValue) !== 'undefined' ? elementsObj[id].value = elementsObj[id].defaultValue : elementsObj[id].value = 0) : '';
            // });
            Object.keys(elementsObj).forEach(function (id) {
                if (typeof (elementsObj[id].value) !== 'undefined') {
                    (typeof (elementsObj[id].defaultValue) !== 'undefined' ? elementsObj[id].value = elementsObj[id].defaultValue : elementsObj[id].value = 0)
                }
                if (elementsObj[id].options) {
                    for (let optionId in elementsObj[id].options) {
                        for (let elementId in elementsObj[id].options[optionId].elements) {
                            if (!elementsObj[id].options[optionId].unitType) {
                                let element = elementsObj[id].options[optionId].elements[elementId];
                                if (element.hasOwnProperty("default") && element.default == true)
                                    element.active = true;
                                else
                                    element.active = false;
                            }
                        }
                    }
                }
            });

            state.fourthStepParametersSelected = JSON.parse(JSON.stringify(state.fourthStepParameters));
        },

        // NVS-78 Metoda do czyszczenia wartości kalkulatora do wartości domyślnych
        cleanParamsValueCalc(state) {

            let elementsObj = state.calculatorParameters;

            //elementsObj['atmospheric_pressure'].options[1].disabled = true

            Object.keys(elementsObj).forEach(function (id) {
                if (typeof (elementsObj[id].value) !== 'undefined') {
                    (typeof (elementsObj[id].defaultValue) !== 'undefined' ? elementsObj[id].value = elementsObj[id].defaultValue : elementsObj[id].value = 0)
                }
                if (elementsObj[id].options) {
                    for (let option of Object.values(elementsObj[id].options)) {
                        option.disabled = option.defaultDisabled;
                    }
                    for (let optionId in elementsObj[id].options) {
                        for (let elementId in elementsObj[id].options[optionId].elements) {
                            if (!elementsObj[id].options[optionId].unitType) {
                                let element = elementsObj[id].options[optionId].elements[elementId];
                                if (element.hasOwnProperty("default") && element.default == true)
                                    element.active = true;
                                else
                                    element.active = false;
                            }
                        }
                    }
                }
            });
        },

        roundValue(state, payload) {
            for (let element in payload.elements) {
                if (payload.elements[element].active == true) {

                    if (typeof (payload.value) != 'number') {
                        payload.value = payload.value.replace(",", ".");

                        if (payload.value.split(".").length > 2) {
                            let newValue = "";
                            let splitedNumber = payload.value.split(".");

                            for (let i = 0; i < 2; i++) {
                                newValue += splitedNumber[i] + ".";
                            }

                            newValue = newValue.substring(0, newValue.length - 1);

                            payload.value = newValue;
                        }
                    }

                    if (payload.displayUser && (payload.value.endsWith(".") || payload.value == 0 || payload.value == "" || payload == "-")) {
                        payload.out = payload.value;
                        return;
                    }

                    let roundedValue = parseFloat(payload.value).toFixed(payload.elements[element].unit.decimal_places);
                    if (roundedValue != 0 && (roundedValue.indexOf(',') > -1 || roundedValue.indexOf('.') > -1))
                        roundedValue = roundedValue.replace(/\.?0+$/, "");

                    payload.out = roundedValue;
                }

            }
        },

        changeParamValue(state, payload) {
            let param = state.fourthStepParameters[payload.param_id];

            let tmpRound = {
                type: 'roundValue',
                elements: payload.option.elements,
                value: payload.value,
                out: ""
            }

            this.commit("roundValue", tmpRound);

            let tmpPayload = {
                type: 'calcRestoreUnit',
                param: param,
                option: payload.option,
                value: tmpRound.out,
                out: ""
            }

            this.commit("calcRestoreUnit", tmpPayload);
            param.value = tmpPayload.out;
        },

        changeParamValueCalc(state, payload) {
            let param = state.calculatorParameters[payload.param_id];

            let tmpRound = {
                type: 'roundValue',
                elements: payload.option.elements,
                value: payload.value,
                out: ""
            }

            this.commit("roundValue", tmpRound);

            let tmpPayload = {
                type: 'calcRestoreUnit',
                param: param,
                option: payload.option,
                value: tmpRound.out,
                out: ""
            }

            this.commit("calcRestoreUnit", tmpPayload);
            param.value = tmpPayload.out;
        },

        setBafaParamValue(state, payload) {
            let _value = state.bafaParameters[payload.param_id].options[payload.option_id].value;
            let _min = state.bafaParameters[payload.param_id].options[payload.option_id].min_value;
            let _max = state.bafaParameters[payload.param_id].options[payload.option_id].max_value;

           if (!isNaN(payload.value)) {
               _value = Math.min(parseFloat(payload.value), _max);
               _value = Math.max(_value, _min);
            }

            state.bafaParameters[payload.param_id].options[payload.option_id].value = _value
            payload.out = _value
        },

        selectElementOfOptionInParam(state, payload) {
            let Obj = state.fourthStepParameters[payload.param_id].options[payload.option_id];
            let elementsObj = Obj.elements;

            Object.keys(elementsObj).forEach(function (id) {
                elementsObj[id].active = false;
            });

            elementsObj[payload.element_id].active = true;

            if (Obj.hasOwnProperty("unitType") && elementsObj[payload.element_id].hasOwnProperty("unit")) {
                this.commit({
                    type: 'changeSelectedUnitInValueUnitMap',
                    param_id: payload.param_id,
                    unitDescription: elementsObj[payload.element_id].value
                });
            }
        },

        selectElementOfOptionInParamCalc(state, payload) {
            let Obj = state.calculatorParameters[payload.param_id].options[payload.option_id];
            if (Obj && Obj.elements) {
                let elementsObj = Obj.elements;

                Object.keys(elementsObj).forEach(function (id) {
                    elementsObj[id].active = false;
                });

                elementsObj[payload.element_id].active = true;

                if (Obj.hasOwnProperty("unitType") && elementsObj[payload.element_id].hasOwnProperty("unit")) {
                    this.commit({
                        type: 'changeSelectedUnitInValueUnitMap',
                        param_id: payload.param_id,
                        unitDescription: elementsObj[payload.element_id].value
                    });
                }
            }
        },

        selectElementOfOptionInParamBaf(state, payload) {

            let Obj = state.bafaParameters[payload.param_id].options[payload.option_id];
            let elementsObj = Obj.elements;

            Object.keys(elementsObj).forEach(function (id) {

                elementsObj[id].active = false;
            });

            elementsObj[payload.element_id].active = true;

            // if (Obj.hasOwnProperty("unitType") && elementsObj[payload.element_id].hasOwnProperty("unit")) {
            //     this.commit({
            //         type: 'chacgeSelectedUnitInValueUnitMap',
            //         param_id: payload.param_id,
            //         unitDescription: elementsObj[payload.element_id].value
            //     });
            // }
        },

        selectElementOfPositionFan(state, payload) {

            let elements = this.state.accessories.fan_positions;

            Object.keys(elements).forEach(function (id) {
                Vue.set(elements[id], 'active', false);
            });

            Vue.set(elements[payload.id], 'active', true);
        },

        selectElementOfVariableValues(state, payload) {
            let valueId = payload.valueId;
            let v_translation = '';

            state.appVariables.forEach((variable) => {

                if (variable.code === payload.elementKey) {
                    variable.values.forEach((variableValue) => {
                        variableValue.forEach((translation) => {
                            Vue.set(translation, 'active', false);
                        });
                        Vue.set(variableValue, 'active', false);
                    });
                    variable.values[valueId].forEach((translation) => {
                        Vue.set(translation, 'active', true);
                        v_translation = translation.value
                    });
                    Vue.set(state.productCard.custom.variables, payload.elementKey, variable.values[valueId][0]['code']);
                    Vue.set(state.productCard.custom.variables, 't_' + payload.elementKey, v_translation);
                }
            })
        },

        // NVS-152
        selectElementOfCorrosionProtectionValues(state, payload) {
            state.productCard['custom'].corrosion_protection.values[payload.elementKey].value = payload.valueId
            if(payload.connectedKey) state.productCard['custom'].corrosion_protection.values[payload.connectedKey].value = payload.connectedValue

            const summary = state.productCard.custom.summary.values;
            let keys = Object.keys(summary);
            for (let key of keys) {
                if (key.includes('surcharge') && summary.hasOwnProperty(key) && typeof summary[key] === "object" && (summary[key].title == payload.surcharge || summary[key].title.includes('przeciwkorozyjna'))) delete summary[key];
            }

            if(payload.surcharge) {
                const surcharge = state.offerSurcharges.find(el => el.code == payload.surcharge);
                if(surcharge) {
                    const mappedSurcharge = {
                        title: surcharge.code,
                        value: surcharge.default_price + ' EUR',
                        id: surcharge.id[0],
                        hidePrice: false,
                        non_standard_surcharges: surcharge.non_standard_surcharges,
                        options: {},
                        price: surcharge.default_price,
                        is_image_visible: surcharge.language[0].is_image_visible,
                        image: surcharge.language[0].image,
                    }

                    let number = keys.filter(el => el.includes('surcharge')).length

                    let keyName = 'surcharge_' + number;
                    Vue.set(summary, keyName, mappedSurcharge);
                }
            }
        },

        changeActiveConfigurationStep(state, payload) {
            state.activeConfigurationStep = payload.step;
        },

        selectLang(state, payload) {

            state.languages.push({
                id: state.activeLang.id,
                name: state.activeLang.name,
                imgSrc: state.activeLang.imgSrc
            });

            state.activeLang.id = payload.id;
            state.activeLang.name = payload.name;
            state.activeLang.imgSrc = payload.imgSrc;

            localStorage.setItem('activeLang', payload.id);

            state.languages.forEach((lang, index) => {
                lang.id === payload.id ? state.languages.splice(index, 1) : '';
            });

            state.languages.sort(function (a, b) {
                let textA = a;
                let textB = b;
                return (textA.name < textB.name) ? -1 : (textA.name > textB.name) ? 1 : 0;
            });
        },

        translate(state, payload) {
            let selectedValue = null;

            if (state.activeLang && state.activeLang.id != "")
                selectedValue = state.translations.find(x => x.code === payload.code && x.id_language === state.activeLang.id);

            if (selectedValue) {
                payload.out = selectedValue.value;
            } else {
                // if (!(payload && payload.hasOwnProperty("displayErrors") && payload.displayErrors == false))
                // console.error('Missing translation: ' + payload.code);
                payload.out = payload.code;
            }
        },

        getVariable(state, payload) {

            let variableLabel = payload.code;

            let variableValues = [];

            if (variableLabel == '' || null) {
                payload.out = variableLabel;
                return;
            }

            let variableObject = state.appVariables.find(x => x.code === variableLabel);
            if (variableObject === undefined) {
                return;
            }

            let variableTranslation = variableObject.language.find(x => x.id_language === state.activeLang.id);
            if (variableTranslation == '' || null || undefined) {
                payload.out = variableLabel;
                return;
            }

            for (let variableValueObject of variableObject.values) {
                let variableValue = variableValueObject.find(x => x.id_language === state.activeLang.id);
                if (variableValue !== null && variableValue !== undefined) {
                    variableValues.push(variableValue);
                }
            }

            variableTranslation = variableTranslation.value;
            let variableDefaultKey = 0;
            for (let indexVal in variableObject.values) {
                if (variableObject.values.hasOwnProperty(indexVal) && variableObject.values[indexVal].length) {
                    if (variableObject.values[indexVal][0]['code'] === variableObject.default_value_code) {
                        variableDefaultKey = indexVal;
                    }
                }
            }


            payload.out = {variableTranslation, variableDefaultKey, variableValues};

        },

        getActiveElementOfParamOption(state, payload) {
            try {
                let option = payload.option;
                let elementsObj = option.elements;

                for (let element in elementsObj) {
                    if (elementsObj[element].active == true) {
                        payload.out = elementsObj[element];
                        return;
                    }
                }
                payload.out = null;
            } catch (e) {
                payload.out = null;
            }
        },

        calcUnit(state, payload) {
            try {
                let option = payload.option;
                let elementsObj = option.elements;

                for (let element in elementsObj) {
                    if (elementsObj[element].active == true) {

                        let roundedValue = parseFloat((payload.param.value - elementsObj[element].unit.a0 / elementsObj[element].unit.a0d) * elementsObj[element].unit.a1d / elementsObj[element].unit.a1).toFixed(elementsObj[element].unit.decimal_places)
                        if (roundedValue != 0 && (roundedValue.indexOf(',') > -1 || roundedValue.indexOf('.') > -1))
                            roundedValue = roundedValue.replace(/\.?0+$/, "");

                        payload.out = roundedValue;
                        return;
                    }
                }
                payload.out = payload.param.value;
            } catch (e) {
                payload.out = payload.param.value;
            }

        },

        calcRestoreUnit(state, payload) {
            try {
                let option = payload.option;
                let elementsObj = option.elements;

                for (let element in elementsObj) {
                    if (elementsObj[element].active == true) {
                        payload.out = parseFloat(payload.value) * elementsObj[element].unit.a1 / elementsObj[element].unit.a1d + elementsObj[element].unit.a0 / elementsObj[element].unit.a0d;
                        return;
                    }
                }
                payload.out = payload.value;
            } catch (e) {
                payload.out = payload.value;
            }

        },

        setSelectedUnit(state, payload) {

            // if (payload.paramId && payload.unitType && payload.unitId) {
            //     let paramContainer = state.fourthStepParameters[payload.paramId];
            //
            //     if (paramContainer && paramContainer.hasOwnProperty("value") && paramContainer.hasOwnProperty("options")) {
            //         for (let optionId in paramContainer.options) {
            //             let option = paramContainer.options[optionId];
            //             if (option.hasOwnProperty("unitType") && option.unitType == payload.unitType && option.hasOwnProperty("elements")) {
            //                 for (let elementId in option.elements) {
            //                     let element = option.elements[elementId];
            //                     if (element && element.hasOwnProperty("unit") && element.unit.id == payload.unitId) {
            //                         element.active = true;
            //
            //                         this.state.fourthStepParamsLastUnitChanges = {
            //                             userChanged: false,
            //                             unit: null,
            //                             param_id: payload.paramId,
            //                             option_id: optionId,
            //                             element_id: elementId,
            //                             unitType: payload.unitType,
            //                             subId: payload.paramId + "|" + optionId + "|" + payload.unitType + "|" + elementId
            //                         };
            //
            //                         state.isAdjustResultDisabled = false;
            //                     } else {
            //                         element.active = false;
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // }

            if (state.ValueUnitMap[payload.paramId] && state.ValueUnitMap[payload.paramId].selected && state.ValueUnitMap[payload.paramId].selected.unit.id != payload.unitId) {
                this.commit({
                    type: 'changeSelectedUnitInValueUnitMap',
                    param_id: payload.paramId,
                    userChanged: false,
                    unitId: payload.unitId
                });
            }
        },
        loadSecondStepData(state, payload) {
            let elements = state.appFanSortsList;
            let FanSortsIds = [];

            for (let appPath of state.appPathsList) {
                if (appPath['id_app_fan_type'] == state.selectedFirstStepElement.id && appPath['id_app_material_sort'] == 0 && appPath['id_app_fan_sort']) {
                    FanSortsIds[appPath['id_app_fan_sort']] = true;
                }
            }

            if (FanSortsIds.length > 0) {
                for (let item of elements) {
                    if (!FanSortsIds[item['id']])
                        continue;

                    let secondStepElement = {
                        id: item['id'],
                        title_translation_code: item['title_translation_code'],
                        imgSrc: item['image'],
                        description_translation_code: item['description_translation_code'],
                        multiple_fans: item['multiple_fans'],
                    };

                    state.secondStepElements.push(secondStepElement);
                }
            }
        },

        loadThirdStepData(state, payload) {
            let elements = state.appMaterialSortList;

            let MaterialsIds = [];
            for (let appPath of state.appPathsList) {
                if (appPath['id_app_fan_type'] == state.selectedFirstStepElement.id && appPath['id_app_material_sort'] != 0 && appPath['id_app_fan_sort'] == state.selectedSecondStepElement.id) {
                    MaterialsIds[appPath['id_app_material_sort']] = true;
                }
            }

            if (MaterialsIds.length > 0) {
                for (let item of elements) {
                    if (!MaterialsIds[item['id']])
                        continue;

                    let thirdStepElement = {
                        id: item['id'],
                        title_translation_code: item['title_translation_code'],
                        imgSrc: item['image'],
                    };

                    state.thirdStepElements.push(thirdStepElement);
                }
            }

            if (state.thirdStepElements.length < 2) {
                let defaultId = -1;

                if (state.thirdStepElements.length == 1 && state.thirdStepElements[0].id)
                    defaultId = state.thirdStepElements[0].id;

                state.selectedThirdStepElement.id = defaultId;
            }
        },

        selectStep(state, payload) {
            if (payload.step === 1) {
                let stepElement = state.firstStepElements.find(x => x.id === payload.id);
                if (stepElement !== undefined) {
                    state.selectedFirstStepElement = stepElement;
                }
            } else if (payload.step === 2) {
                let stepElement = state.secondStepElements.find(x => x.id === payload.id);
                if (stepElement !== undefined) {
                    state.selectedSecondStepElement = stepElement;
                }
            } else if (payload.step === 3) {
                let stepElement = state.thirdStepElements.find(x => x.id === payload.id);
                if (stepElement !== undefined) {
                    state.selectedThirdStepElement = stepElement;
                }
            }
        },

        selectFirstStepElement(state, payload) {
            if (state.selectedFirstStepElement.id != payload.id) {
                this.commit("clearSelectedSecoundStepElement", payload);
                this.commit("clearSelectedThirdStepElement", payload);
            }

            state.selectedFirstStepElement.id = payload.id;
            state.selectedFirstStepElement.name = payload.name;
            state.selectedFirstStepElement.imgSrc = payload.imgSrc;
            state.selectedFirstStepElement.description = payload.description;
            state.selectedFirstStepElement.default_minimum_material_density = payload.default_minimum_material_density;
            state.selectedFirstStepElement.default_minimum_material_density_value = payload.default_minimum_material_density_value;
            state.selectedFirstStepElement.delta_t_condition_check = payload.delta_t_condition_check;
        },

        selectSecondStepElement(state, payload) {
            if (state.selectedSecondStepElement.id != payload.id) {
                this.commit("clearSelectedThirdStepElement", payload);
            }

            state.selectedSecondStepElement.id = payload.id;
            state.selectedSecondStepElement.name = payload.name;
            state.selectedSecondStepElement.imgSrc = payload.imgSrc;
            state.selectedSecondStepElement.multiple_fans = payload.multiple_fans;
        },

        selectThirdStepElement(state, payload) {
            state.selectedThirdStepElement.id = payload.id;
            state.selectedThirdStepElement.name = payload.name;
            state.selectedThirdStepElement.imgSrc = payload.imgSrc;
        },

        selectAccessoriesPrice(state, payload) {
            state.accessories.fan_price = payload.fan_price
        },

        clearSelectedSecoundStepElement(state, payload) {
            state.selectedSecondStepElement = {
                id: -1,
                name: '',
                imgName: '',
                multiple_fans: null,
            }
        },
        clearSelectedThirdStepElement(state, payload) {
            state.selectedThirdStepElement = {
                id: -1,
                name: '',
                imgName: ''
            }
        },
        removeNotification: function (state) {
            state.notifications.splice(state.notifications.length - 1, 1);
        },
        removeAllNotifications: function (state) {
            state.notifications = [];
        },
        pushNewNotification: function (state, payload) {
            state.notifications.push({'type': payload.type, 'title': payload.title, 'content': payload.content});
        }
    },
    getters: {
        getNotification: function (state) {
            if (state.notifications.length === 0) {
                return false;
            }
            return state.notifications[state.notifications.length - 1];
        },

        isOfferEditable: function (state, getters) {
            if (state.productCard.custom.is_approved) return false;
            if (state.productCard.custom.is_cancelled) return true;
            if (getters.getUserRole !== 'admin' && state.productCard.loaded === true) return false;
            return true;
        },

        getIfUserLogged: function (state) {
            return state.isUserLogged;
        },

        getVariableActiveValue: function (state) {
            return function (variableCode) {
                let variable = state.appVariables.find(x => x.code === variableCode);

                if (variable === undefined) {
                    return;
                }

                let activeValue = variable.values.find(x => x['active'] === true);
                if (activeValue === undefined) {
                    activeValue = variable.values.find(x => x[0].code === variable.default_value_code);
                }

                let activeTranslation = activeValue.find(x => x.id_language === state.activeLang.id);
                if (activeTranslation === undefined) {
                    return;
                }

                return activeTranslation.value;

            }


        },

        getUserRole: function (state) {
            return state.userRole;
        },

        getUsername: function (state) {
            if (state.isUserLogged) {
                return state.userEmail;
            } else return '-';
        },

        getVariableDefaultValue: function (state) {
            return function (code) {
                let out = '';
                state.appVariables.forEach((variable) => {
                    if (variable.code === code) {
                        variable.values.forEach((value) => {
                            if (value[0].code === variable.default_value_code) {
                                value.forEach((translation) => {
                                    if (translation.id_language === state.activeLang.id) {
                                        out = translation.value;
                                    }
                                })
                            }
                        });
                    }
                })
                return out;
            }
        }
    }


})
